import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { map } from "lodash";
import Select from "react-select";
import InputMask from "react-input-mask";

import Config from "config";
import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
  Table,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Collapse,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
import IdentificationCard from "components/Common/IdentificationCard";
import TableComponent from "components/Common/TableComponent";
import OperationList from "components/Common/OperationListHm";
import DocumentHm from "components/Common/DocumentPmeHm";
import DocumentFusionHm from "components/Common/DocumentFusionHm";
import SouscriptionsCard from "components/Common/SouscriptionsCard";
import SectionCard from "components/Common/SectionCard";
import SouscriptionFinaliseesListHm from "components/Common/SouscriptionFinaliseesListHm";
import InvestissementListHm from "components/Common/InvestissementListHm";
import { makeSelectStyles } from "../../common/selectStyles";
import {
  FiLayers,
  FiChevronUp,
  FiChevronDown,
  FiCalendar,
  FiEdit3,
} from "react-icons/fi";
const investissEdit = () => {
  const api = Config.backOffice.apiName;
  const backUrl = Config.backOffice.url;
  let { id } = useParams();
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("auth_token_" + api);
  const navigate = useNavigate();
  const [modal, setModal] = useState(false);
  const [wait, setWait] = useState(1000);
  const toggleModal = () => setModal(!modal);
  const [investData, setInvestData] = useState([]);
  const colStyle = {
    width: "20em", // Largeur fixe pour la première colonne
    whiteSpace: "wrap", // Empêche le texte de revenir à la ligne
    display: "inline-block", // Permet de conserver le texte sur une seule ligne
    color: "#7f7f7f",
    verticalAlign: "middle", // Alignement vertical au centre pour le texte
    display: "flex", // Utilisation de flexbox pour aligner les éléments horizontalement
    alignItems: "center", // Centrage vertical du texte et de l'input
  };
  const layout = localStorage.getItem("layoutMode");
  const [isCaractInvestAccordionOpen, setIsCaractInvestAccordionOpen] =
    useState(true);
  const toggleCaractInvestAccordion = () =>
    setIsCaractInvestAccordionOpen((o) => !o);
  const [isDescriptionAccordionOpen, setIsDescriptionAccordionOpen] =
    useState(true);
  const toggleDescriptionAccordion = () =>
    setIsDescriptionAccordionOpen((o) => !o);
  const [isHonorairesAccordionOpen, setIsHonorairesAccordionOpen] =
    useState(true);
  const toggleHonorairesAccordion = () =>
    setIsHonorairesAccordionOpen((o) => !o);
  const [isLoyersAccordionOpen, setIsLoyersAccordionOpen] = useState(true);
  const toggleLoyersAccordion = () => setIsLoyersAccordionOpen((o) => !o);
  const [isAmortissementsAccordionOpen, setIsAmortissementsAccordionOpen] =
    useState(true);
  const toggleAmortissementsAccordion = () =>
    setIsAmortissementsAccordionOpen((o) => !o);
  const [isExploitationAccordionOpen, setIsExploitationAccordionOpen] =
    useState(true);
  const toggleExploitationAccordion = () =>
    setIsExploitationAccordionOpen((o) => !o);
  // state global
  const [openSections, setOpenSections] = useState({});

  // toggle indépendant par section
  const toggleSectionAccordion = (key) => {
    setOpenSections((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const styles = makeSelectStyles(layout);
  const tableaustyles = {
    background: "#555B21",
    color: "white",
    paddingTop: "5px",
    paddingBottom: "5px",
    //minWidth: "1em",
  };
  //meta title
  const [activeTab, setActiveTab] = useState("details"); // État pour contrôler l'affichage

  const handleTabClick = (tab) => {
    setActiveTab(tab); // Mettre à jour l'état lors du clic sur un onglet
  };
  document.title = "Investissements | Edit";
  const CustomNavTabs = () => {
    const navStyle = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
    };
    const navStyleClient = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
      textAlign: "left",
    };

    return (
      <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
        <NavItem>
          <NavLink
            style={navStyle}
            className={`nav-link ${activeTab === "details" ? "active" : ""}`}
            onClick={() => handleTabClick("details")}
          >
            {!loading ? (
              "Détails investissements"
            ) : (
              <span
                className="placeholder col-3"
                style={{ height: "1em" }}
              ></span>
            )}
          </NavLink>
        </NavItem>
      </Nav>
    );
  };
  /*************************   PME  *******************************/
  const [pme, setPmeData] = useState({ data: [] });
  const [selectedPme, setSelectedPme] = useState("");
  const handlePmeChange = (e) => {
    setSelectedPme(e);
  };
  const getPme = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investissements/pmes`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((pme) => {
          setPmeData(pme);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderPmeOptions = () => {
    return [
      {
        options: pme.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /*************************   END PME *******************************/
  /*************************   Classe immobilisation  *******************************/
  const [classe, setClasseData] = useState({ data: [] });
  const [selectedClasse, setSelectedClasse] = useState("");
  const handleClasseChange = (e) => {
    setSelectedClasse(e);
  };
  const getClasse = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/investissements/classe_immobilisations`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((pme) => {
          setClasseData(pme);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderClasseOptions = () => {
    return [
      {
        options: classe.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /*************************   END Classe *******************************/
  /*************************   Tranche  *******************************/
  const [tranche, setTrancheData] = useState({ data: [] });
  const [selectedTranche, setSelectedTranche] = useState("");
  const handleTrancheChange = (e) => {
    setSelectedTranche(e);
  };
  const getTranche = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/investissements/tranchs?${id}&pme_id=${
          selectedPme?.value || ""
        }&tranch_id=${selectedTranche?.value || ""}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((pme) => {
          setTrancheData(pme);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderTrancheOptions = () => {
    return [
      {
        options: tranche.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /*************************   END Tranche *******************************/
  /*************************   Code  *******************************/
  const [code, setCodeData] = useState({ data: [] });
  const [selectedCode, setSelectedCode] = useState("");
  const handleCodeChange = (e) => {
    setSelectedCode(e);
  };
  const getCode = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/investissements/codes_investissements`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((pme) => {
          setCodeData(pme);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderCodeOptions = () => {
    return [
      {
        options: code.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /*************************   END Code *******************************/
  /*************************   Direction  *******************************/
  const [direction, setDirectionData] = useState({ data: [] });
  const [selectedDirection, setSelectedDirection] = useState("");
  const handleDirectionChange = (e) => {
    setSelectedDirection(e);
  };
  const getDirection = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investissements/partenaires3`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((pme) => {
          setDirectionData(pme);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderDirectionOptions = () => {
    return [
      {
        options: direction.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /*************************   END Direction *******************************/
  /****Numéro *****/
  const [selectedNumero, setSelectedNumero] = useState("");
  const handleNumeroChange = (e) => {
    setSelectedNumero(e.target.value);
  };
  /******End Numéro */
  /****designation Courte *****/
  const [selectedDesignationCourte, setSelectedDesignationCourte] =
    useState("");
  const handleDesignationCourteChange = (e) => {
    setSelectedDesignationCourte(e.target.value);
  };
  /******End designation Courte */
  /****designation Op *****/
  const [selectedDesignationOp, setSelectedDesignationOp] = useState("");
  const handleDesignationOpChange = (e) => {
    setSelectedDesignationOp(e.target.value);
  };
  /******End designation Op */
  /****Honoraire 1 *****/
  const [selectedHonoraire1, setSelectedHonoraire1] = useState("");
  const handleHonoraire1Change = (e) => {
    setSelectedHonoraire1(e.target.value);
  };
  /******End Honoraire 1 */
  /****Honoraire 2 *****/
  const [selectedHonoraire2, setSelectedHonoraire2] = useState("");
  const handleHonoraire2Change = (e) => {
    setSelectedHonoraire2(e.target.value);
  };
  /******End Honoraire 2 */
  /****Honoraire 3 *****/
  const [selectedHonoraire3, setSelectedHonoraire3] = useState("");
  const handleHonoraire3Change = (e) => {
    setSelectedHonoraire3(e.target.value);
  };
  /******End Honoraire 3 */
  /****Taux loyer *****/
  const [selectedTauxLoyer, setSelectedTauxLoyer] = useState("");
  const handleTauxLoyerChange = (e) => {
    setSelectedTauxLoyer(e.target.value);
  };
  /******End Taux Loyer */
  /****Taux service *****/
  const [selectedTauxService, setSelectedTauxService] = useState("");
  const handleTauxServiceChange = (e) => {
    setSelectedTauxService(e.target.value);
  };
  /******End Taux Loyer */
  /*************************   Statut  *******************************/
  const [statut, setStatutData] = useState({ data: [] });
  const [selectedStatut, setSelectedStatut] = useState("");
  const handleStatutChange = (e) => {
    setSelectedStatut(e);
  };
  const getStatut = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/investissements/statuts_investissements`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((pme) => {
          setStatutData(pme);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderStatutOptions = () => {
    return [
      {
        options: statut.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /*************************   END Statut *******************************/
  /*************************   PartenaireIndu  *******************************/
  const [partenaireIndu, setPartenaireInduData] = useState({ data: [] });
  const [selectedPartenaireIndu, setSelectedPartenaireIndu] = useState("");
  const handlePartenaireInduChange = (e) => {
    setSelectedPartenaireIndu(e);
  };
  const getPartenaireIndu = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investissements/partenaires3 `, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((pme) => {
          setPartenaireInduData(pme);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderPartenaireInduOptions = () => {
    return [
      {
        options: partenaireIndu.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /*************************   END PartenaireIndu *******************************/
  // Exploitant
  const [exploitant, setExploitantData] = useState({ data: [] });
  const [selectedExploitant, setSelectedExploitant] = useState();
  const handleExploitantChange = (e) => {
    setSelectedExploitant(e);
  };
  const getExploitant = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investissements/partenaires2 `, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((pme) => {
          setExploitantData(pme);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderExploitantOptions = () => {
    return [
      {
        options: exploitant.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  // Section
  const [selectedSection, setSelectedSection] = useState("");
  const handleSectionChange = (e) => {
    setSelectedSection(e.target.value);
  };

  // N° cadastre
  const [selectedCadastre, setSelectedCadastre] = useState("");
  const handleCadastreChange = (e) => {
    setSelectedCadastre(e.target.value);
  };

  // Contenance
  const [selectedContenance, setSelectedContenance] = useState("");
  const handleContenanceChange = (e) => {
    setSelectedContenance(e.target.value);
  }; // Contenance2
  const [selectedContenance2, setSelectedContenance2] = useState("");
  const handleContenance2Change = (e) => {
    setSelectedContenance2(e.target.value);
  };
  // Nature
  const [selectedNature, setSelectedNature] = useState("");
  const handleNatureChange = (e) => {
    setSelectedNature(e.target.value);
  };
  // Nature2
  const [selectedNature2, setSelectedNature2] = useState("");
  const handleNature2Change = (e) => {
    setSelectedNature2(e.target.value);
  };
  // Lieu-dit
  const [selectedLieuDit, setSelectedLieuDit] = useState("");
  const handleLieuDitChange = (e) => {
    setSelectedLieuDit(e.target.value);
  };

  // Adresse
  const [selectedAdresse, setSelectedAdresse] = useState("");
  const handleAdresseChange = (e) => {
    setSelectedAdresse(e.target.value);
  };

  // Code postal
  const [selectedCodePostal, setSelectedCodePostal] = useState("");
  const handleCodePostalChange = (e) => {
    setSelectedCodePostal(e.target.value);
  };

  // Commune
  const [selectedCommune, setSelectedCommune] = useState("");
  const handleCommuneChange = (e) => {
    setSelectedCommune(e.target.value);
  };

  // Date PV livraison
  const [selectedDateLivraison, setSelectedDateLivraison] = useState("");
  const handleDateLivraisonChange = (e) => {
    setSelectedDateLivraison(e.target.value);
  };
  // Date obtention
  const [selectedDateObtention, setSelectedDateObtention] = useState("");
  const handleDateObtentionChange = (e) => {
    setSelectedDateObtention(e.target.value);
  };
  // Date protocol
  const [selectedDateProtocol, setSelectedDateProtocol] = useState("");
  const handleDateProtocleChange = (e) => {
    setSelectedDateProtocol(e.target.value);
  };

  // Montant (€)
  const [selectedMontant, setSelectedMontant] = useState("");
  const handleMontantChange = (e) => {
    setSelectedMontant(e.target.value);
  };
  // Montant (€)2
  const [selectedMontant2, setSelectedMontant2] = useState("");
  const handleMontant2Change = (e) => {
    setSelectedMontant2(e.target.value);
  };
  // Prix unitaire (€)
  const [selectedPrixUnitaire, setSelectedPrixUnitaire] = useState("");
  const handlePrixUnitaireChange = (e) => {
    setSelectedPrixUnitaire(e.target.value);
  };
  // Prix unitaire (€)2
  const [selectedPrixUnitaire2, setSelectedPrixUnitaire2] = useState("");
  const handlePrixUnitaire2Change = (e) => {
    setSelectedPrixUnitaire2(e.target.value);
  };

  // % rétrocession exploitant
  const [selectedPourcentageRetro, setSelectedPourcentageRetro] = useState("");
  const handlePourcentageRetroChange = (e) => {
    setSelectedPourcentageRetro(e.target.value);
  };

  // Rétrocession exploitant (€)
  const [selectedRetroExploitant, setSelectedRetroExploitant] = useState("");
  const handleRetroExploitantChange = (e) => {
    setSelectedRetroExploitant(e.target.value);
  };
  // Durée amortissement (mois)
  const [selectedDureeAmortissement, setSelectedDureeAmortissement] =
    useState("");
  const handleDureeAmortissementChange = (e) => {
    setSelectedDureeAmortissement(e.target.value);
  };

  // Agrément

  const [selectedAgrement, setSelectedAgrement] = useState();
  const handleAgrementChange = (e) => {
    setSelectedAgrement(e);
  };

  const OuiNon = {
    data: [
      { id: 1, label: "Oui" },
      { id: 2, label: "Non" },
    ],
  };
  const renderOuiNonOptions = () => {
    return [
      {
        options: OuiNon.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  // Subvention
  const [selectedSubvention, setSelectedSubvention] = useState();
  const handleSubventionChange = (e) => {
    setSelectedSubvention(e);
  };
  // Subvention(€)
  const [selectedSubvention2, setSelectedSubvention2] = useState("");
  const handleSubvention2Change = (e) => {
    setSelectedSubvention2(e.target.value);
  };
  // PartieVersante
  const [partieVersante, setPartieVersanteData] = useState({ data: [] });
  const [selectedPartieVersante, setSelectedPartieVersante] = useState();
  const handlePartieVersanteChange = (e) => {
    setSelectedPartieVersante(e);
  };
  const getPartie = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/investissements/provenance_subventions `,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((pme) => {
          setPartieVersanteData(pme);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderPartieOptions = () => {
    return [
      {
        options: partieVersante.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  // Base éligible (€)
  const [selectedBaseEligible, setSelectedBaseEligible] = useState("");
  const handleBaseEligibleChange = (e) => {
    setSelectedBaseEligible(e.target.value);
  };
  // % réduction impôt
  const [
    selectedPourcentageReductionImpot,
    setSelectedPourcentageReductionImpot,
  ] = useState("");
  const handlePourcentageReductionImpotChange = (e) => {
    setSelectedPourcentageReductionImpot(e.target.value);
  };
  // Réduction impôt (€)
  const [selectedReductionImpot, setSelectedReductionImpot] = useState("");
  const handleReductionImpotChange = (e) => {
    setSelectedReductionImpot(e.target.value);
  };
  /******************************* HMF Loyer *******************************************/
  const [formLoyer, setFormLoyer] = useState({});

  const onAddFormLoyer = () => {
    const modifiedDonneesLoyer = [...formLoyer];
    console.log(modifiedDonneesLoyer);
    modifiedDonneesLoyer.push({
      index: modifiedDonneesLoyer.length + 1,
      id: null,
      date: null,
      num_facture: null,
      montant_ht: null,
    });
    console.log(modifiedDonneesLoyer);
    setFormLoyer(modifiedDonneesLoyer);
  };

  const onDeleteFormLoyer = (id) => {
    var modifiedDonneesLoyer = [...formLoyer];
    modifiedDonneesLoyer = modifiedDonneesLoyer.filter(
      (x) => x["index"] !== id
    );
    setFormLoyer(modifiedDonneesLoyer);
  };
  const handleInputLoyerChange = (index, field, value) => {
    const modifiedDonneesLoyer = formLoyer.map((donnesLoyer) => {
      if (donnesLoyer.index === index) {
        return {
          ...donnesLoyer,
          [field]: value,
        };
      }
      return donnesLoyer;
    });

    setFormLoyer(modifiedDonneesLoyer);
  };
  /******************************* END HMF DonneesLoyer *******************************************/
  /******************************* HMF Amortissements *******************************************/
  const [formAmortissements, setFormAmortissements] = useState({});

  const onAddFormAmortissements = () => {
    const modifiedAmortissements = [...formAmortissements];
    console.log(modifiedAmortissements);
    modifiedAmortissements.push({
      index: modifiedAmortissements.length + 1,
      id: null,
      date: null,
      montant: null,
    });
    console.log(modifiedAmortissements);
    setFormAmortissements(modifiedAmortissements);
  };

  const onDeleteFormAmortissements = (id) => {
    var modifiedAmortissements = [...formAmortissements];
    modifiedAmortissements = modifiedAmortissements.filter(
      (x) => x["index"] !== id
    );
    setFormAmortissements(modifiedAmortissements);
  };
  const handleInputAmortissementsChange = (index, field, value) => {
    const modifiedAmortissements = formAmortissements.map(
      (donnesAmortissements) => {
        if (donnesAmortissements.index === index) {
          return {
            ...donnesAmortissements,
            [field]: value,
          };
        }
        return donnesAmortissements;
      }
    );

    setFormAmortissements(modifiedAmortissements);
  };
  /******************************* END HMF Amortissements *******************************************/
  //****SHOW */
  const [showField, setShowFied] = useState("");
  const getShow = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/investissements/show_fields?pme_id=${
          selectedPme?.value || ""
        }&statuts_investissement_id=${
          selectedStatut?.value || ""
        }&subvention2=${selectedSubvention?.value || ""}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((reservation) => {
          setShowFied(reservation);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const handleNavigate = () => {
    localStorage.setItem("key", true);
    localStorage.setItem("lastId", id);
    navigate(-1);
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (
      selectedPme === null ||
      selectedStatut === null ||
      selectedSubvention === null ||
      selectedCode === null
    ) {
      toast.error("Remplissez les champs obligatoires");
    } else {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/investissements/${id}`,
          {
            method: "PATCH",
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              investissement: {
                id: id,
                numero: selectedNumero,
                pme_id: selectedPme?.value || "",
                section: selectedSection,
                n_cadastre: selectedCadastre,
                contenance: selectedContenance,
                contenance_2: selectedContenance2,
                nature: selectedNature,
                nature_2: selectedNature2,
                n_protocole: "",
                lieudit: selectedLieuDit,
                code_postal: selectedCodePostal,
                commune: selectedCommune,
                date_protocole: selectedDateProtocol,
                montant: selectedMontant,
                montant_2: selectedMontant2,
                date_pv_livraison: selectedDateLivraison,
                pourc_retrocession_exploitant: selectedPourcentageRetro,
                agrement: selectedAgrement?.value || "",
                subvention: selectedSubvention2,
                date_obtention_subvention: selectedDateObtention,
                base_eligible_investissement: selectedBaseEligible,
                taux_reduction_impot: selectedPourcentageReductionImpot,
                reduction_impot: selectedReductionImpot,
                duree_amortissement: selectedDureeAmortissement,
                description: selectedDesignationOp,
                tranch_id: selectedTranche?.value || "",
                codes_investissement_id: selectedCode?.value || "",
                statuts_investissement_id: selectedStatut?.value || "",
                partenaire2_id: selectedExploitant?.value || "",
                partenaire3_id: selectedPartenaireIndu?.value || "",
                provenance_subvention_id: selectedPartieVersante?.value || "",
                subvention2: selectedSubvention?.value || "",
                adresse: selectedAdresse,
                retrocession: selectedRetroExploitant,
                prix_unitaire: selectedPrixUnitaire,
                prix_unitaire_2: selectedPrixUnitaire2,
                classe_immobilisation_id: selectedClasse?.value || "",
                designation_courte: selectedDesignationCourte,
                taux_loyer: selectedTauxLoyer,
                taux_service: selectedTauxService,
                honoraire_1: selectedHonoraire1,
                honoraire_2: selectedHonoraire2,
                honoraire_3: selectedHonoraire3,
              },
              hmf_loyers: formLoyer
                ? formLoyer.map((obj) => {
                    delete obj.index;
                    return obj;
                  })
                : [],

              hmf_amortissements: formAmortissements
                ? formAmortissements.map((obj) => {
                    delete obj.index;
                    return obj;
                  })
                : [],
            }),
          }
        );

        if (response.ok) {
          console.log("PATCH request successful");
          handleNavigate();
        } else {
          console.error("PATCH request failed");
          const responseData = await response.json();

          if (responseData && responseData.investissement_validation) {
            // Si le champ "contact_validation" est présent dans la réponse JSON
            const errors = responseData?.investissement_validation;

            errors.forEach((error) => {
              toast.error(error);
            });
          } else {
            toast.error("Une erreur s'est produite");
          }
        }
      } catch (error) {
        console.error("An error occurred", error);
        toast.error("Une erreur s'est produite");
      }
    }
  };
  useEffect(() => {
    setLoading(true);
    const getData = async () => {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/investissements/${id}/edit`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.status === 403) {
          navigate(`${backUrl}/forbidden`);
        }
        if (response.status === 500) {
          navigate(`${backUrl}/error`);
        }
        if (response.status === 203) {
          navigate(`${backUrl}/error404`);
        }
        if (response.status === 401) {
          localStorage.removeItem("auth_token_" + api);
          localStorage.removeItem("authUser_" + api);
          localStorage.removeItem("sideBar_" + api);
          navigate(`${backUrl}/login`);
          window.location.reload(false);
        }
        // if (!response.ok) {
        //   localStorage.removeItem("auth_token_"+api);
        //   localStorage.removeItem("authUser_"+api);
        //   localStorage.removeItem("sideBar_"+api);
        //   history("/backoffice_test/login");
        //   window.location.reload(false);
        //   throw new Error(`Request failed with status: ${response.status}`);
        // }

        const investData = await response.json();
        setInvestData(investData);
        setSelectedPme(
          investData.detail_investissement?.[
            "Caractéristiques de l'investissement"
          ].PME
        );
        setSelectedDesignationOp(
          investData.detail_investissement?.["Description"]?.[
            "Désignation de l'opération"
          ]
        );
        setSelectedDesignationCourte(
          investData.detail_investissement?.["Description"]?.[
            "Désignation courte"
          ]
        );
        setSelectedClasse(
          investData.detail_investissement?.[
            "Caractéristiques de l'investissement"
          ]?.["Classe immobilisation"]
        );
        setSelectedTranche(
          investData.detail_investissement?.[
            "Caractéristiques de l'investissement"
          ]?.["Tranche"]
        );
        setSelectedCode(
          investData.detail_investissement?.[
            "Caractéristiques de l'investissement"
          ]?.["Code secteur"]
        );
        setSelectedDirection(
          investData.detail_investissement?.[
            "Caractéristiques de l'investissement"
          ]?.["Direction produit"]
        );
        setSelectedStatut(
          investData.detail_investissement?.[
            "Caractéristiques de l'investissement"
          ]?.["Statut"]
        );
        setSelectedDateProtocol(
          investData.detail_investissement?.[
            "Caractéristiques de l'investissement"
          ]?.["Date protocole"]
        );
        setSelectedNumero(
          investData.detail_investissement?.[
            "Caractéristiques de l'investissement"
          ]?.["Numéro"]
        );
        setSelectedPartenaireIndu(
          investData.detail_investissement?.["Description"]?.[
            "Partenaires industriels"
          ]
        );

        setSelectedHonoraire1(
          investData.detail_investissement?.["Honoraires"]?.["Honoraire 1"]
        );
        setSelectedHonoraire2(
          investData.detail_investissement?.["Honoraires"]?.["Honoraire 2"]
        );
        setSelectedHonoraire3(
          investData.detail_investissement?.["Honoraires"]?.["Honoraire 3"]
        );
        setSelectedTauxLoyer(
          investData.detail_investissement?.["Honoraires"]?.["Taux loyer"]
        );
        setSelectedTauxService(
          investData.detail_investissement?.["Honoraires"]?.["Taux service"]
        );
        setSelectedExploitant(
          investData.detail_investissement?.["Exploitation"]?.["Exploitant"]
        );
        setSelectedSection(
          investData.detail_investissement?.["Exploitation"]?.["Section"]
        );
        setSelectedCadastre(
          investData.detail_investissement?.["Exploitation"]?.["N° cadastre"]
        );
        setSelectedContenance(
          investData.detail_investissement?.["Lot 1"]?.["Contenance"]
        );
        setSelectedContenance2(
          investData.detail_investissement?.["Lot 2"]?.["Contenance 2"]
        );
        setSelectedNature(
          investData.detail_investissement?.["Lot 1"]?.["Nature"]
        );
        setSelectedNature2(
          investData.detail_investissement?.["Lot 2"]?.["Nature 2"]
        );
        setSelectedLieuDit(
          investData.detail_investissement?.["Exploitation"]?.["Lieu-dit"]
        );
        setSelectedAdresse(
          investData.detail_investissement?.["Exploitation"]?.["Adresse"]
        );
        setSelectedCodePostal(
          investData.detail_investissement?.["Exploitation"]?.["Code postal"]
        );
        setSelectedCommune(
          investData.detail_investissement?.["Exploitation"]?.["Commune"]
        );
        setSelectedDateLivraison(
          investData.detail_investissement?.["Exploitation"]?.[
            "Date PV livraison"
          ]
        );
        setSelectedMontant(
          investData.detail_investissement?.["Lot 1"]?.["Montant (€)"]
        );
        setSelectedMontant2(
          investData.detail_investissement?.["Lot 2"]?.["Montant 2 (€)"]
        );
        setSelectedPrixUnitaire(
          investData.detail_investissement?.["Lot 1"]?.["Prix unitaire (€)"]
        );
        setSelectedPrixUnitaire2(
          investData.detail_investissement?.["Lot 2"]?.["Prix unitaire 2 (€)"]
        );
        setSelectedPourcentageRetro(
          investData.detail_investissement?.["Total"]?.[
            "% rétrocession exploitant"
          ]
        );
        setSelectedRetroExploitant(
          investData.detail_investissement?.["Total"]?.[
            "Rétrocession exploitant (€)"
          ]
        );
        setSelectedDureeAmortissement(
          investData.detail_investissement?.["Total"]?.[
            "Durée amortissement (mois)"
          ]
        );
        setSelectedAgrement(
          investData.detail_investissement?.["Exploitation"]?.["Agrément"]
        );
        setSelectedSubvention(
          investData.detail_investissement?.["Exploitation"]?.["Subvention"]
        );
        setSelectedSubvention2(
          investData.detail_investissement?.["Exploitation"]?.[
            "Subventions (€)"
          ]
        );

        setSelectedBaseEligible(
          investData.detail_investissement?.["Total"]?.["Base éligible (€)"]
        );
        setSelectedReductionImpot(
          investData.detail_investissement?.["Total"]?.["Réduction impôt (€)"]
        );
        setSelectedPourcentageReductionImpot(
          investData.detail_investissement?.["Total"]?.["% réduction impôt"]
        );
        setSelectedPartieVersante(
          investData.detail_investissement?.["Exploitation"]?.[
            "Partie versante"
          ]
        );
        setSelectedDateObtention(
          investData.detail_investissement?.["Exploitation"]?.[
            "Date obtention subvention"
          ]
        );
        setFormLoyer(
          investData.detail_investissement?.["Loyers"]?.[
            "Loyers investissement"
          ].data
        );
        setFormAmortissements(
          investData.detail_investissement?.["Tableau des amortissements"]?.[
            "Tableau amortissements"
          ].data
        );

        setWait(0);
      } catch (error) {
        // Handle any other errors that might occur during the fetch
        console.error("Error fetching data:", error.message);
      }
    };

    const fetchData = async () => {
      try {
        await getData();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
    if (localStorage.getItem("key") === "true") {
      toast.success("Mise à jour réussie");
      localStorage.setItem("key", "false");
    }
  }, []);
  useEffect(() => {
    if (wait === 0) {
      setLoading(false);
    }
  }, [wait]);
  useEffect(() => {
    if (!loading) {
      getPme();
      getClasse();
      getTranche();
      getCode();
      getDirection();
      getStatut();
      getPartenaireIndu();
      getExploitant();
      getPartie();
      getShow();
    }
  }, [loading]);
  useEffect(() => {
    if (!loading) {
      getTranche();
    }
  }, [selectedPme, selectedTranche]);
  useEffect(() => {
    if (!loading) {
      getShow();
    }
  }, [selectedStatut, selectedSubvention, selectedPme]);
  let linkState = { active: "" };

  if (activeTab == "details") {
    linkState.active = "details";
  } else if (activeTab == "contact") {
    linkState.active = "contact";
  } else {
    linkState.active = "details";
  }
  useEffect(() => {
    const montant = parseFloat(selectedMontant) || 0;
    const montant2 = parseFloat(selectedMontant2) || 0;
    const pourcentageRetro = parseFloat(selectedPourcentageRetro) || 0;

    setSelectedRetroExploitant(
      parseFloat(((montant + montant2) * (pourcentageRetro / 100)).toFixed(2))
    );
  }, [loading, selectedMontant, selectedPourcentageRetro, selectedMontant2]);

  useEffect(() => {
    const montant = parseFloat(selectedMontant) || 0;
    const montant2 = parseFloat(selectedMontant2) || 0;

    setSelectedBaseEligible(parseFloat((montant + montant2).toFixed(2)));
  }, [loading, selectedMontant, selectedMontant2]);

  useEffect(() => {
    const montant = parseFloat(selectedMontant) || 0;
    const montant2 = parseFloat(selectedMontant2) || 0;
    const pourcentageReduction =
      parseFloat(selectedPourcentageReductionImpot) || 1; // éviter division par zéro

    setSelectedReductionImpot(
      parseFloat(
        ((montant + montant2) * (pourcentageReduction / 100)).toFixed(2)
      )
    );
  }, [loading, selectedBaseEligible, selectedPourcentageReductionImpot]);
  const sections = [
    { key: "Lot 1", title: "Lot 1" },
    { key: "Lot 2", title: "Lot 2" },
    { key: "Total", title: "Total" },
  ];
  return (
    <React.Fragment>
      <div className="page-content" style={{ fontFamily: "sans-serif" }}>
        <div className="container-fluid">
          <Row>
            <Col lg="12">
              <Card>
                <CardBody className="border-bottom">
                  <div className="d-flex align-items-center">
                    <h5
                      className="mb-0 card-title flex-grow-1"
                      style={{ fontWeight: "bold", display: "flex" }}
                    >
                      {!loading ? (
                        <>
                          <Link
                            to={`${backUrl}/investissements`}
                            style={{
                              color: "#555B21",
                              textDecoration: "underline !important",
                            }}
                          >
                            Investissements
                          </Link>{" "}
                        </>
                      ) : (
                        <span
                          className="placeholder col-3"
                          style={{ height: "1em" }}
                        ></span>
                      )}
                      <i className="bx bx-caret-right"></i>{" "}
                      {!loading ? (
                        investData.sil
                      ) : (
                        <>
                          <span
                            className="placeholder col-3"
                            style={{ height: "1em" }}
                          ></span>
                        </>
                      )}
                    </h5>
                  </div>

                  <div className="d-flex justify-content-end">
                    <div className="d-flex align-items-end">
                      <button
                        className="btn btn-sm btn-primary"
                        onClick={handleSubmit}
                      >
                        <i className="bx bx-send"></i> Valider
                      </button>
                      &nbsp; &nbsp;
                      <Link
                        to="#"
                        onClick={() => navigate(-1)}
                        className="btn btn-sm btn-soft-secondary "
                        style={{ width: "88.43px" }}
                      >
                        <i className="bx bx-arrow-back"></i> Annuler
                      </Link>
                    </div>
                  </div>
                </CardBody>
                {CustomNavTabs()}
                <CardBody>
                  {activeTab === "details" && (
                    <div>
                      {!loading ? (
                        <>
                          <Row>
                            <Col sm="6">
                              {investData?.detail_investissement?.[
                                "Caractéristiques de l'investissement"
                              ] ? (
                                <Card
                                  className="shadow-sm border-0 overflow-hidden mb-4"
                                  style={{ borderRadius: "12px" }}
                                >
                                  {/* En‑tête cliquable */}
                                  <div
                                    className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                    style={{
                                      background: "#555B21",
                                      letterSpacing: "0.5px",
                                      cursor: "pointer",
                                      userSelect: "none",
                                    }}
                                    onClick={toggleCaractInvestAccordion}
                                  >
                                    <div className="d-flex align-items-center">
                                      <span style={{ fontSize: "0.82rem" }}>
                                        Caractéristiques de
                                        l&apos;investissement
                                      </span>
                                    </div>
                                    {isCaractInvestAccordionOpen ? (
                                      <FiChevronUp size={16} />
                                    ) : (
                                      <FiChevronDown size={16} />
                                    )}
                                  </div>

                                  <Collapse
                                    isOpen={isCaractInvestAccordionOpen}
                                  >
                                    <CardBody className="p-0">
                                      <div
                                        className="fields-container"
                                        style={{ paddingBottom: "8px" }}
                                      >
                                        {Object.entries(
                                          investData?.detail_investissement?.[
                                            "Caractéristiques de l'investissement"
                                          ] || {}
                                        ).map(([key, value], index) => (
                                          <React.Fragment key={index}>
                                            {/* PME* */}
                                            {key === "PME" && (
                                              <div
                                                className="field-item px-2 py-1"
                                                style={{
                                                  backgroundColor: "white",
                                                  transition: "all 0.15s ease",
                                                  borderLeft:
                                                    "3px solid #dc3545",
                                                  marginBottom: "1px",
                                                  position: "relative",
                                                }}
                                                onMouseEnter={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "#ffe6e6";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#dc3545";
                                                }}
                                                onMouseLeave={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "white";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#dc3545";
                                                }}
                                              >
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        PME
                                                      </span>
                                                      <span className="ms-1 text-primary">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col xs={12} md={8}>
                                                    <Select
                                                      value={
                                                        selectedPme?.label ==
                                                        null
                                                          ? null
                                                          : selectedPme
                                                      }
                                                      onChange={handlePmeChange}
                                                      options={renderPmeOptions()}
                                                      isClearable
                                                      classNamePrefix="select2-selection"
                                                      styles={styles(
                                                        selectedPme === null
                                                      )}
                                                      menuPortalTarget={
                                                        document.body
                                                      }
                                                      placeholder="Sélectionner une PME..."
                                                    />
                                                    {selectedPme === null && (
                                                      <div className="invalid-feedback d-block mt-1 small">
                                                        PME ne peut pas être
                                                        vide
                                                      </div>
                                                    )}
                                                  </Col>
                                                </Row>
                                              </div>
                                            )}

                                            {/* Classe immobilisation */}
                                            {key ===
                                              "Classe immobilisation" && (
                                              <div
                                                className="field-item px-2 py-1"
                                                style={{
                                                  backgroundColor: "white",
                                                  transition: "all 0.15s ease",
                                                  borderLeft:
                                                    "3px solid transparent",
                                                  marginBottom: "1px",
                                                  position: "relative",
                                                }}
                                                onMouseEnter={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "#e3f2fd";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#007bff";
                                                }}
                                                onMouseLeave={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "white";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "transparent";
                                                }}
                                              >
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        Classe immobilisation
                                                      </span>
                                                      <span className="ms-1 text-primary">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col xs={12} md={8}>
                                                    <Select
                                                      value={
                                                        selectedClasse?.label ==
                                                        null
                                                          ? null
                                                          : selectedClasse
                                                      }
                                                      onChange={
                                                        handleClasseChange
                                                      }
                                                      options={renderClasseOptions()}
                                                      isClearable
                                                      classNamePrefix="select2-selection"
                                                      styles={styles(false)}
                                                      menuPortalTarget={
                                                        document.body
                                                      }
                                                      placeholder="Sélectionner une classe..."
                                                    />
                                                  </Col>
                                                </Row>
                                              </div>
                                            )}

                                            {/* Tranche */}
                                            {key === "Tranche" && (
                                              <div
                                                className="field-item px-2 py-1"
                                                style={{
                                                  backgroundColor: "white",
                                                  transition: "all 0.15s ease",
                                                  borderLeft:
                                                    "3px solid transparent",
                                                  marginBottom: "1px",
                                                  position: "relative",
                                                }}
                                                onMouseEnter={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "#e3f2fd";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#007bff";
                                                }}
                                                onMouseLeave={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "white";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "transparent";
                                                }}
                                              >
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        Tranche
                                                      </span>
                                                      <span className="ms-1 text-primary">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col xs={12} md={8}>
                                                    <Select
                                                      value={
                                                        selectedTranche?.label ==
                                                        null
                                                          ? null
                                                          : selectedTranche
                                                      }
                                                      onChange={
                                                        handleTrancheChange
                                                      }
                                                      options={renderTrancheOptions()}
                                                      isClearable
                                                      classNamePrefix="select2-selection"
                                                      styles={styles(false)}
                                                      menuPortalTarget={
                                                        document.body
                                                      }
                                                      placeholder="Sélectionner une tranche..."
                                                    />
                                                  </Col>
                                                </Row>
                                              </div>
                                            )}

                                            {/* Direction produit */}
                                            {key === "Direction produit" && (
                                              <div
                                                className="field-item px-2 py-1"
                                                style={{
                                                  backgroundColor: "white",
                                                  transition: "all 0.15s ease",
                                                  borderLeft:
                                                    "3px solid transparent",
                                                  marginBottom: "1px",
                                                  position: "relative",
                                                }}
                                                onMouseEnter={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "#e3f2fd";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#007bff";
                                                }}
                                                onMouseLeave={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "white";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "transparent";
                                                }}
                                              >
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        Direction produit
                                                      </span>
                                                      <span className="ms-1 text-primary">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col xs={12} md={8}>
                                                    <Select
                                                      value={
                                                        selectedDirection?.label ==
                                                        null
                                                          ? null
                                                          : selectedDirection
                                                      }
                                                      onChange={
                                                        handleDirectionChange
                                                      }
                                                      options={renderDirectionOptions()}
                                                      isClearable
                                                      classNamePrefix="select2-selection"
                                                      styles={styles(false)}
                                                      menuPortalTarget={
                                                        document.body
                                                      }
                                                      placeholder="Sélectionner une direction..."
                                                    />
                                                  </Col>
                                                </Row>
                                              </div>
                                            )}

                                            {/* Code secteur* */}
                                            {key === "Code secteur" && (
                                              <div
                                                className="field-item px-2 py-1"
                                                style={{
                                                  backgroundColor: "white",
                                                  transition: "all 0.15s ease",
                                                  borderLeft:
                                                    "3px solid #dc3545",
                                                  marginBottom: "1px",
                                                  position: "relative",
                                                }}
                                                onMouseEnter={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "#ffe6e6";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#dc3545";
                                                }}
                                                onMouseLeave={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "white";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#dc3545";
                                                }}
                                              >
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        Code secteur
                                                      </span>
                                                      <span className="ms-1 text-primary">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col xs={12} md={8}>
                                                    <Select
                                                      value={
                                                        selectedCode?.label ==
                                                        null
                                                          ? null
                                                          : selectedCode
                                                      }
                                                      onChange={
                                                        handleCodeChange
                                                      }
                                                      options={renderCodeOptions()}
                                                      isClearable
                                                      classNamePrefix="select2-selection"
                                                      styles={styles(
                                                        selectedCode === null
                                                      )}
                                                      menuPortalTarget={
                                                        document.body
                                                      }
                                                      placeholder="Sélectionner un code..."
                                                    />
                                                    {selectedCode === null && (
                                                      <div className="invalid-feedback d-block mt-1 small">
                                                        Code secteur ne peut pas
                                                        être vide
                                                      </div>
                                                    )}
                                                  </Col>
                                                </Row>
                                              </div>
                                            )}

                                            {/* Statut* */}
                                            {key === "Statut" && (
                                              <div
                                                className="field-item px-2 py-1"
                                                style={{
                                                  backgroundColor: "white",
                                                  transition: "all 0.15s ease",
                                                  borderLeft:
                                                    "3px solid #dc3545",
                                                  marginBottom: "1px",
                                                  position: "relative",
                                                }}
                                                onMouseEnter={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "#ffe6e6";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#dc3545";
                                                }}
                                                onMouseLeave={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "white";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#dc3545";
                                                }}
                                              >
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        Statut
                                                      </span>
                                                      <span className="ms-1 text-primary">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col xs={12} md={8}>
                                                    <Select
                                                      value={
                                                        selectedStatut?.label ==
                                                        null
                                                          ? null
                                                          : selectedStatut
                                                      }
                                                      onChange={
                                                        handleStatutChange
                                                      }
                                                      options={renderStatutOptions()}
                                                      isClearable
                                                      classNamePrefix="select2-selection"
                                                      styles={styles(
                                                        selectedStatut === null
                                                      )}
                                                      menuPortalTarget={
                                                        document.body
                                                      }
                                                      placeholder="Sélectionner un statut..."
                                                    />
                                                    {selectedStatut ===
                                                      null && (
                                                      <div className="invalid-feedback d-block mt-1 small">
                                                        Statut ne peut pas être
                                                        vide
                                                      </div>
                                                    )}
                                                  </Col>
                                                </Row>
                                              </div>
                                            )}

                                            {/* Numéro */}
                                            {key === "Numéro" && (
                                              <div
                                                className="field-item px-2 py-1"
                                                style={{
                                                  backgroundColor: "white",
                                                  transition: "all 0.15s ease",
                                                  borderLeft:
                                                    "3px solid transparent",
                                                  marginBottom: "1px",
                                                  position: "relative",
                                                }}
                                                onMouseEnter={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "#e3f2fd";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#007bff";
                                                }}
                                                onMouseLeave={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "white";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "transparent";
                                                }}
                                              >
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        Numéro
                                                      </span>
                                                      <span className="ms-1 text-primary">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col xs={12} md={8}>
                                                    <input
                                                      className="form-control form-control-sm shadow-sm border-0"
                                                      value={selectedNumero}
                                                      required
                                                      onChange={
                                                        handleNumeroChange
                                                      }
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        backgroundColor:
                                                          "#f8f9fa",
                                                        borderRadius: "6px",
                                                        padding:
                                                          "0.375rem 0.75rem",
                                                        height: "32px",
                                                      }}
                                                    />
                                                    <FiEdit3
                                                      size={12}
                                                      className="position-absolute text-muted"
                                                      style={{
                                                        right: "8px",
                                                        top: "50%",
                                                        transform:
                                                          "translateY(-50%)",
                                                        pointerEvents: "none",
                                                        opacity: 0.9,
                                                      }}
                                                    />
                                                  </Col>
                                                </Row>
                                              </div>
                                            )}

                                            {/* Date protocole (si présente dans les données) */}
                                            {key === "Date protocole" &&
                                              showField?.displayed_fields?.includes(
                                                "date_protocole"
                                              ) && (
                                                <div
                                                  className="field-item px-2 py-1"
                                                  style={{
                                                    backgroundColor: "white",
                                                    transition:
                                                      "all 0.15s ease",
                                                    borderLeft:
                                                      "3px solid transparent",
                                                    marginBottom: "1px",
                                                    position: "relative",
                                                  }}
                                                  onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#e3f2fd";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#007bff";
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "transparent";
                                                  }}
                                                >
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          Date protocole
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <div className="input-wrapper position-relative">
                                                        <InputMask
                                                          mask="99/99/9999"
                                                          value={
                                                            selectedDateProtocol
                                                          }
                                                          className="form-control form-control-sm shadow-sm border-0 input-color"
                                                          onChange={(
                                                            dateString
                                                          ) =>
                                                            setSelectedDateProtocol(
                                                              dateString.target
                                                                .value
                                                            )
                                                          }
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            backgroundColor:
                                                              "#f8f9fa",
                                                            borderRadius: "6px",
                                                            padding:
                                                              "0.375rem 2rem 0.375rem 0.5rem",
                                                            height: "32px",
                                                            transition:
                                                              "all 0.2s ease",
                                                          }}
                                                        />
                                                        <FiCalendar
                                                          size={12}
                                                          className="position-absolute text-muted"
                                                          style={{
                                                            right: "8px",
                                                            top: "50%",
                                                            transform:
                                                              "translateY(-50%)",
                                                            pointerEvents:
                                                              "none",
                                                            opacity: 0.9,
                                                          }}
                                                        />
                                                      </div>
                                                    </Col>
                                                  </Row>
                                                </div>
                                              )}
                                          </React.Fragment>
                                        ))}

                                        {/* Date protocole ajoutée si absente dans les données */}
                                        {showField?.displayed_fields?.includes(
                                          "date_protocole"
                                        ) &&
                                          !Object.keys(
                                            investData?.detail_investissement?.[
                                              "Caractéristiques de l'investissement"
                                            ] || {}
                                          ).includes("Date protocole") && (
                                            <div
                                              className="field-item px-2 py-1"
                                              style={{
                                                backgroundColor: "white",
                                                transition: "all 0.15s ease",
                                                borderLeft:
                                                  "3px solid transparent",
                                                marginBottom: "1px",
                                                position: "relative",
                                              }}
                                              onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "#e3f2fd";
                                                e.currentTarget.style.borderLeftColor =
                                                  "#007bff";
                                              }}
                                              onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "white";
                                                e.currentTarget.style.borderLeftColor =
                                                  "transparent";
                                              }}
                                            >
                                              <Row className="align-items-center g-1">
                                                <Col xs={12} md={4}>
                                                  <div className="d-flex align-items-center small text-muted">
                                                    <span
                                                      className="fw-medium"
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        letterSpacing: "0.2px",
                                                      }}
                                                    >
                                                      Date protocole
                                                    </span>
                                                    <span className="ms-1 text-primary">
                                                      :
                                                    </span>
                                                  </div>
                                                </Col>
                                                <Col xs={12} md={8}>
                                                  <div className="input-wrapper position-relative">
                                                    <InputMask
                                                      mask="99/99/9999"
                                                      value={
                                                        selectedDateProtocol
                                                      }
                                                      className="form-control form-control-sm shadow-sm border-0 input-color"
                                                      onChange={(dateString) =>
                                                        setSelectedDateProtocol(
                                                          dateString.target
                                                            .value
                                                        )
                                                      }
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        backgroundColor:
                                                          "#f8f9fa",
                                                        borderRadius: "6px",
                                                        padding:
                                                          "0.375rem 2rem 0.375rem 0.5rem",
                                                        height: "32px",
                                                        transition:
                                                          "all 0.2s ease",
                                                      }}
                                                    />
                                                    <FiCalendar
                                                      size={12}
                                                      className="position-absolute text-muted"
                                                      style={{
                                                        right: "8px",
                                                        top: "50%",
                                                        transform:
                                                          "translateY(-50%)",
                                                        pointerEvents: "none",
                                                        opacity: 0.9,
                                                      }}
                                                    />
                                                  </div>
                                                </Col>
                                              </Row>
                                            </div>
                                          )}
                                      </div>
                                    </CardBody>
                                  </Collapse>
                                </Card>
                              ) : null}

                              {investData?.detail_investissement?.[
                                "Description"
                              ] ? (
                                <Card
                                  className="shadow-sm border-0 overflow-hidden mb-4"
                                  style={{ borderRadius: "12px" }}
                                >
                                  {/* En‑tête cliquable */}
                                  <div
                                    className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                    style={{
                                      background: "#555B21",
                                      letterSpacing: "0.5px",
                                      cursor: "pointer",
                                      userSelect: "none",
                                    }}
                                    onClick={toggleDescriptionAccordion}
                                  >
                                    <div className="d-flex align-items-center">
                                      <span style={{ fontSize: "0.82rem" }}>
                                        Description
                                      </span>
                                    </div>
                                    {isDescriptionAccordionOpen ? (
                                      <FiChevronUp size={16} />
                                    ) : (
                                      <FiChevronDown size={16} />
                                    )}
                                  </div>

                                  <Collapse isOpen={isDescriptionAccordionOpen}>
                                    <CardBody className="p-0">
                                      <div
                                        className="fields-container"
                                        style={{ paddingBottom: "8px" }}
                                      >
                                        {Object.entries(
                                          investData?.detail_investissement?.[
                                            "Description"
                                          ] || {}
                                        ).map(([key, value], index) => (
                                          <React.Fragment key={index}>
                                            {/* Désignation courte */}
                                            {key === "Désignation courte" && (
                                              <div
                                                className="field-item px-2 py-1"
                                                style={{
                                                  backgroundColor: "white",
                                                  transition: "all 0.15s ease",
                                                  borderLeft:
                                                    "3px solid transparent",
                                                  marginBottom: "1px",
                                                  position: "relative",
                                                }}
                                                onMouseEnter={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "#e3f2fd";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#007bff";
                                                }}
                                                onMouseLeave={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "white";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "transparent";
                                                }}
                                              >
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        Désignation courte
                                                      </span>
                                                      <span className="ms-1 text-primary">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col xs={12} md={8}>
                                                    <input
                                                      className="form-control form-control-sm shadow-sm border-0"
                                                      value={
                                                        selectedDesignationCourte
                                                      }
                                                      required
                                                      onChange={
                                                        handleDesignationCourteChange
                                                      }
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        backgroundColor:
                                                          "#f8f9fa",
                                                        borderRadius: "6px",
                                                        padding:
                                                          "0.375rem 0.75rem",
                                                        height: "32px",
                                                      }}
                                                    />
                                                    <FiEdit3
                                                      size={12}
                                                      className="position-absolute text-muted"
                                                      style={{
                                                        right: "8px",
                                                        top: "50%",
                                                        transform:
                                                          "translateY(-50%)",
                                                        pointerEvents: "none",
                                                        opacity: 0.9,
                                                      }}
                                                    />
                                                  </Col>
                                                </Row>
                                              </div>
                                            )}

                                            {/* Désignation de l'opération */}
                                            {key ===
                                              "Désignation de l'opération" && (
                                              <div
                                                className="field-item px-2 py-1"
                                                style={{
                                                  backgroundColor: "white",
                                                  transition: "all 0.15s ease",
                                                  borderLeft:
                                                    "3px solid transparent",
                                                  marginBottom: "1px",
                                                  position: "relative",
                                                }}
                                                onMouseEnter={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "#e3f2fd";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#007bff";
                                                }}
                                                onMouseLeave={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "white";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "transparent";
                                                }}
                                              >
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        Désignation de
                                                        l&apos;opération
                                                      </span>
                                                      <span className="ms-1 text-primary">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col xs={12} md={8}>
                                                    <input
                                                      className="form-control form-control-sm shadow-sm border-0"
                                                      value={
                                                        selectedDesignationOp
                                                      }
                                                      required
                                                      onChange={
                                                        handleDesignationOpChange
                                                      }
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        backgroundColor:
                                                          "#f8f9fa",
                                                        borderRadius: "6px",
                                                        padding:
                                                          "0.375rem 0.75rem",
                                                        height: "32px",
                                                      }}
                                                    />
                                                    <FiEdit3
                                                      size={12}
                                                      className="position-absolute text-muted"
                                                      style={{
                                                        right: "8px",
                                                        top: "50%",
                                                        transform:
                                                          "translateY(-50%)",
                                                        pointerEvents: "none",
                                                        opacity: 0.9,
                                                      }}
                                                    />
                                                  </Col>
                                                </Row>
                                              </div>
                                            )}

                                            {/* Partenaires industriels */}
                                            {key ===
                                              "Partenaires industriels" && (
                                              <div
                                                className="field-item px-2 py-1"
                                                style={{
                                                  backgroundColor: "white",
                                                  transition: "all 0.15s ease",
                                                  borderLeft:
                                                    "3px solid transparent",
                                                  marginBottom: "1px",
                                                  position: "relative",
                                                }}
                                                onMouseEnter={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "#e3f2fd";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#007bff";
                                                }}
                                                onMouseLeave={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "white";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "transparent";
                                                }}
                                              >
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        Partenaires industriels
                                                      </span>
                                                      <span className="ms-1 text-primary">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col xs={12} md={8}>
                                                    <Select
                                                      value={
                                                        selectedPartenaireIndu?.label ==
                                                        null
                                                          ? null
                                                          : selectedPartenaireIndu
                                                      }
                                                      onChange={
                                                        handlePartenaireInduChange
                                                      }
                                                      options={renderPartenaireInduOptions()}
                                                      isClearable
                                                      classNamePrefix="select2-selection"
                                                      styles={styles(false)}
                                                      menuPortalTarget={
                                                        document.body
                                                      }
                                                      placeholder="Sélectionner un partenaire..."
                                                    />
                                                  </Col>
                                                </Row>
                                              </div>
                                            )}
                                          </React.Fragment>
                                        ))}
                                      </div>
                                    </CardBody>
                                  </Collapse>
                                </Card>
                              ) : null}
                              {investData?.detail_investissement?.[
                                "Honoraires"
                              ] ? (
                                <Card
                                  className="shadow-sm border-0 overflow-hidden mb-4"
                                  style={{ borderRadius: "12px" }}
                                >
                                  {/* En‑tête cliquable */}
                                  <div
                                    className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                    style={{
                                      background: "#555B21",
                                      letterSpacing: "0.5px",
                                      cursor: "pointer",
                                      userSelect: "none",
                                    }}
                                    onClick={toggleHonorairesAccordion}
                                  >
                                    <div className="d-flex align-items-center">
                                      <span style={{ fontSize: "0.82rem" }}>
                                        Honoraires
                                      </span>
                                    </div>
                                    {isHonorairesAccordionOpen ? (
                                      <FiChevronUp size={16} />
                                    ) : (
                                      <FiChevronDown size={16} />
                                    )}
                                  </div>

                                  <Collapse isOpen={isHonorairesAccordionOpen}>
                                    <CardBody className="p-0">
                                      <div
                                        className="fields-container"
                                        style={{ paddingBottom: "8px" }}
                                      >
                                        {Object.entries(
                                          investData?.detail_investissement?.[
                                            "Honoraires"
                                          ] || {}
                                        ).map(([key, value], index) => (
                                          <React.Fragment key={index}>
                                            {/* Honoraire 1 */}
                                            {key === "Honoraire 1" && (
                                              <div
                                                className="field-item px-2 py-1"
                                                style={{
                                                  backgroundColor: "white",
                                                  transition: "all 0.15s ease",
                                                  borderLeft:
                                                    "3px solid transparent",
                                                  marginBottom: "1px",
                                                  position: "relative",
                                                }}
                                                onMouseEnter={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "#e3f2fd";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#007bff";
                                                }}
                                                onMouseLeave={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "white";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "transparent";
                                                }}
                                              >
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        Honoraire 1
                                                      </span>
                                                      <span className="ms-1 text-primary">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col xs={12} md={8}>
                                                    <input
                                                      className="form-control form-control-sm shadow-sm border-0"
                                                      value={selectedHonoraire1}
                                                      required
                                                      onChange={
                                                        handleHonoraire1Change
                                                      }
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        backgroundColor:
                                                          "#f8f9fa",
                                                        borderRadius: "6px",
                                                        padding:
                                                          "0.375rem 0.75rem",
                                                        height: "32px",
                                                      }}
                                                    />
                                                    <FiEdit3
                                                      size={12}
                                                      className="position-absolute text-muted"
                                                      style={{
                                                        right: "8px",
                                                        top: "50%",
                                                        transform:
                                                          "translateY(-50%)",
                                                        pointerEvents: "none",
                                                        opacity: 0.9,
                                                      }}
                                                    />
                                                  </Col>
                                                </Row>
                                              </div>
                                            )}

                                            {/* Honoraire 2 */}
                                            {key === "Honoraire 2" && (
                                              <div
                                                className="field-item px-2 py-1"
                                                style={{
                                                  backgroundColor: "white",
                                                  transition: "all 0.15s ease",
                                                  borderLeft:
                                                    "3px solid transparent",
                                                  marginBottom: "1px",
                                                  position: "relative",
                                                }}
                                                onMouseEnter={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "#e3f2fd";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#007bff";
                                                }}
                                                onMouseLeave={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "white";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "transparent";
                                                }}
                                              >
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        Honoraire 2
                                                      </span>
                                                      <span className="ms-1 text-primary">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col xs={12} md={8}>
                                                    <input
                                                      className="form-control form-control-sm shadow-sm border-0"
                                                      value={selectedHonoraire2}
                                                      required
                                                      onChange={
                                                        handleHonoraire2Change
                                                      }
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        backgroundColor:
                                                          "#f8f9fa",
                                                        borderRadius: "6px",
                                                        padding:
                                                          "0.375rem 0.75rem",
                                                        height: "32px",
                                                      }}
                                                    />
                                                    <FiEdit3
                                                      size={12}
                                                      className="position-absolute text-muted"
                                                      style={{
                                                        right: "8px",
                                                        top: "50%",
                                                        transform:
                                                          "translateY(-50%)",
                                                        pointerEvents: "none",
                                                        opacity: 0.9,
                                                      }}
                                                    />
                                                  </Col>
                                                </Row>
                                              </div>
                                            )}

                                            {/* Honoraire 3 */}
                                            {key === "Honoraire 3" && (
                                              <div
                                                className="field-item px-2 py-1"
                                                style={{
                                                  backgroundColor: "white",
                                                  transition: "all 0.15s ease",
                                                  borderLeft:
                                                    "3px solid transparent",
                                                  marginBottom: "1px",
                                                  position: "relative",
                                                }}
                                                onMouseEnter={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "#e3f2fd";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#007bff";
                                                }}
                                                onMouseLeave={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "white";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "transparent";
                                                }}
                                              >
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        Honoraire 3
                                                      </span>
                                                      <span className="ms-1 text-primary">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col xs={12} md={8}>
                                                    <input
                                                      className="form-control form-control-sm shadow-sm border-0"
                                                      value={selectedHonoraire3}
                                                      required
                                                      onChange={
                                                        handleHonoraire3Change
                                                      }
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        backgroundColor:
                                                          "#f8f9fa",
                                                        borderRadius: "6px",
                                                        padding:
                                                          "0.375rem 0.75rem",
                                                        height: "32px",
                                                      }}
                                                    />
                                                    <FiEdit3
                                                      size={12}
                                                      className="position-absolute text-muted"
                                                      style={{
                                                        right: "8px",
                                                        top: "50%",
                                                        transform:
                                                          "translateY(-50%)",
                                                        pointerEvents: "none",
                                                        opacity: 0.9,
                                                      }}
                                                    />
                                                  </Col>
                                                </Row>
                                              </div>
                                            )}

                                            {/* Taux loyer */}
                                            {key === "Taux loyer" && (
                                              <div
                                                className="field-item px-2 py-1"
                                                style={{
                                                  backgroundColor: "white",
                                                  transition: "all 0.15s ease",
                                                  borderLeft:
                                                    "3px solid transparent",
                                                  marginBottom: "1px",
                                                  position: "relative",
                                                }}
                                                onMouseEnter={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "#e3f2fd";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#007bff";
                                                }}
                                                onMouseLeave={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "white";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "transparent";
                                                }}
                                              >
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        Taux loyer
                                                      </span>
                                                      <span className="ms-1 text-primary">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col xs={12} md={8}>
                                                    <input
                                                      className="form-control form-control-sm shadow-sm border-0"
                                                      value={selectedTauxLoyer}
                                                      required
                                                      onChange={
                                                        handleTauxLoyerChange
                                                      }
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        backgroundColor:
                                                          "#f8f9fa",
                                                        borderRadius: "6px",
                                                        padding:
                                                          "0.375rem 0.75rem",
                                                        height: "32px",
                                                      }}
                                                    />
                                                    <FiEdit3
                                                      size={12}
                                                      className="position-absolute text-muted"
                                                      style={{
                                                        right: "8px",
                                                        top: "50%",
                                                        transform:
                                                          "translateY(-50%)",
                                                        pointerEvents: "none",
                                                        opacity: 0.9,
                                                      }}
                                                    />
                                                  </Col>
                                                </Row>
                                              </div>
                                            )}

                                            {/* Taux service */}
                                            {key === "Taux service" && (
                                              <div
                                                className="field-item px-2 py-1"
                                                style={{
                                                  backgroundColor: "white",
                                                  transition: "all 0.15s ease",
                                                  borderLeft:
                                                    "3px solid transparent",
                                                  marginBottom: "1px",
                                                  position: "relative",
                                                }}
                                                onMouseEnter={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "#e3f2fd";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#007bff";
                                                }}
                                                onMouseLeave={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "white";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "transparent";
                                                }}
                                              >
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        Taux service
                                                      </span>
                                                      <span className="ms-1 text-primary">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col xs={12} md={8}>
                                                    <input
                                                      className="form-control form-control-sm shadow-sm border-0"
                                                      value={
                                                        selectedTauxService
                                                      }
                                                      required
                                                      onChange={
                                                        handleTauxServiceChange
                                                      }
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        backgroundColor:
                                                          "#f8f9fa",
                                                        borderRadius: "6px",
                                                        padding:
                                                          "0.375rem 0.75rem",
                                                        height: "32px",
                                                      }}
                                                    />
                                                    <FiEdit3
                                                      size={12}
                                                      className="position-absolute text-muted"
                                                      style={{
                                                        right: "8px",
                                                        top: "50%",
                                                        transform:
                                                          "translateY(-50%)",
                                                        pointerEvents: "none",
                                                        opacity: 0.9,
                                                      }}
                                                    />
                                                  </Col>
                                                </Row>
                                              </div>
                                            )}
                                          </React.Fragment>
                                        ))}
                                      </div>
                                    </CardBody>
                                  </Collapse>
                                </Card>
                              ) : null}
                              <Col sm="12">
                                {investData?.detail_investissement?.[
                                  "Loyers"
                                ] ? (
                                  <>
                                    <Card
                                      className="shadow-sm border-0 overflow-hidden mb-4"
                                      style={{ borderRadius: "12px" }}
                                    >
                                      {/* En‑tête cliquable */}
                                      <div
                                        className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                        style={{
                                          background: "#555B21",
                                          letterSpacing: "0.5px",
                                          cursor: "pointer",
                                          userSelect: "none",
                                        }}
                                        onClick={toggleLoyersAccordion}
                                      >
                                        <div className="d-flex align-items-center">
                                          <span style={{ fontSize: "0.82rem" }}>
                                            Loyers
                                          </span>
                                        </div>
                                        {isLoyersAccordionOpen ? (
                                          <FiChevronUp size={16} />
                                        ) : (
                                          <FiChevronDown size={16} />
                                        )}
                                      </div>

                                      <Collapse isOpen={isLoyersAccordionOpen}>
                                        <CardBody className="p-2">
                                          <Col sm="12">
                                            <div className="table-responsive">
                                              <table
                                                className="table table-bordered rounded-3 overflow-hidden"
                                                style={{
                                                  borderCollapse: "collapse",
                                                  width: "100%",
                                                }}
                                              >
                                                <thead>
                                                  <tr>
                                                    {investData?.detail_investissement?.[
                                                      "Loyers"
                                                    ]?.[
                                                      "Loyers investissement"
                                                    ].header.map(
                                                      (columnName, index) => (
                                                        <th
                                                          className="text-nowrap"
                                                          style={tableaustyles}
                                                          key={index}
                                                        >
                                                          {columnName}
                                                        </th>
                                                      )
                                                    )}
                                                    <th
                                                      className="text-nowrap"
                                                      style={{
                                                        background: "#555B21",
                                                        color: "white",
                                                        paddingTop: "5px",
                                                        paddingBottom: "5px",
                                                        width: "1%",
                                                      }}
                                                      key="Del"
                                                    ></th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  {formLoyer.map((rowData) => (
                                                    <tr key={rowData.index}>
                                                      {Object.entries(
                                                        rowData
                                                      ).map(([key, value]) =>
                                                        key !== "id" &&
                                                        key !== "index" ? (
                                                          <td key={key}>
                                                            {key === "date" ? (
                                                              <InputMask
                                                                name={key}
                                                                mask="99/99/9999"
                                                                value={value}
                                                                className="form-control form-control-sm input-color"
                                                                onChange={(e) =>
                                                                  handleInputLoyerChange(
                                                                    rowData.index,
                                                                    e.target
                                                                      .name,
                                                                    e.target
                                                                      .value
                                                                  )
                                                                }
                                                              />
                                                            ) : key ===
                                                                "montant_ht" ||
                                                              key ===
                                                                "num_facture" ? (
                                                              <input
                                                                className="form-control form-control-sm"
                                                                defaultValue={
                                                                  value
                                                                }
                                                                name={key}
                                                                onChange={(e) =>
                                                                  handleInputLoyerChange(
                                                                    rowData.index,
                                                                    e.target
                                                                      .name,
                                                                    e.target
                                                                      .value
                                                                  )
                                                                }
                                                              />
                                                            ) : (
                                                              <span>
                                                                {value}
                                                              </span>
                                                            )}
                                                          </td>
                                                        ) : (
                                                          <td
                                                            className="d-none"
                                                            key={key}
                                                          >
                                                            <input
                                                              type="hidden"
                                                              value={value}
                                                              readOnly
                                                            />
                                                          </td>
                                                        )
                                                      )}
                                                      <td
                                                        style={{
                                                          width: "1%",
                                                          textAlign: "center",
                                                        }}
                                                      >
                                                        <i
                                                          className="bx bx-trash"
                                                          style={{
                                                            fontSize: "20px",
                                                            paddingTop: "5px",
                                                            textAlign: "center",
                                                            verticalAlign:
                                                              "middle",
                                                            cursor: "pointer",
                                                          }}
                                                          onClick={() =>
                                                            onDeleteFormLoyer(
                                                              rowData.index
                                                            )
                                                          }
                                                        ></i>
                                                      </td>
                                                    </tr>
                                                  ))}
                                                  <tr>
                                                    <td colSpan="9">
                                                      <button
                                                        type="button"
                                                        style={tableaustyles}
                                                        className="btn btn-info mt-3 mt-lg-0"
                                                        onClick={onAddFormLoyer}
                                                      >
                                                        Ajouter
                                                      </button>
                                                    </td>
                                                  </tr>
                                                </tbody>
                                              </table>
                                            </div>
                                          </Col>
                                        </CardBody>
                                      </Collapse>
                                    </Card>
                                  </>
                                ) : null}
                              </Col>

                              <Col sm="12">
                                {investData?.detail_investissement?.[
                                  "Tableau des amortissements"
                                ] ? (
                                  <>
                                    <Card
                                      className="shadow-sm border-0 overflow-hidden mb-4"
                                      style={{ borderRadius: "12px" }}
                                    >
                                      {/* En‑tête cliquable */}
                                      <div
                                        className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                        style={{
                                          background: "#555B21",
                                          letterSpacing: "0.5px",
                                          cursor: "pointer",
                                          userSelect: "none",
                                        }}
                                        onClick={toggleAmortissementsAccordion}
                                      >
                                        <div className="d-flex align-items-center">
                                          <span style={{ fontSize: "0.82rem" }}>
                                            Tableau des amortissements
                                          </span>
                                        </div>
                                        {isAmortissementsAccordionOpen ? (
                                          <FiChevronUp size={16} />
                                        ) : (
                                          <FiChevronDown size={16} />
                                        )}
                                      </div>

                                      <Collapse
                                        isOpen={isAmortissementsAccordionOpen}
                                      >
                                        <CardBody className="p-2">
                                          <Col sm="12">
                                            <div className="table-responsive">
                                              <table
                                                className="table table-bordered rounded-3 overflow-hidden"
                                                style={{
                                                  borderCollapse: "collapse",
                                                  width: "100%",
                                                }}
                                              >
                                                <thead>
                                                  <tr>
                                                    {investData?.detail_investissement?.[
                                                      "Tableau des amortissements"
                                                    ]?.[
                                                      "Tableau amortissements"
                                                    ].header.map(
                                                      (columnName, index) => (
                                                        <th
                                                          className="text-nowrap"
                                                          style={tableaustyles}
                                                          key={index}
                                                        >
                                                          {columnName}
                                                        </th>
                                                      )
                                                    )}
                                                    <th
                                                      className="text-nowrap"
                                                      style={{
                                                        background: "#555B21",
                                                        color: "white",
                                                        paddingTop: "5px",
                                                        paddingBottom: "5px",
                                                        width: "1%",
                                                      }}
                                                      key="Del"
                                                    ></th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  {formAmortissements.map(
                                                    (rowData) => (
                                                      <tr key={rowData.index}>
                                                        {Object.entries(
                                                          rowData
                                                        ).map(([key, value]) =>
                                                          key !== "id" &&
                                                          key !== "index" ? (
                                                            <td key={key}>
                                                              {key ===
                                                              "date" ? (
                                                                <InputMask
                                                                  name={key}
                                                                  mask="99/99/9999"
                                                                  value={value}
                                                                  className="form-control form-control-sm input-color"
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    handleInputAmortissementsChange(
                                                                      rowData.index,
                                                                      e.target
                                                                        .name,
                                                                      e.target
                                                                        .value
                                                                    )
                                                                  }
                                                                />
                                                              ) : key ===
                                                                "montant" ? (
                                                                <input
                                                                  className="form-control form-control-sm"
                                                                  defaultValue={
                                                                    value
                                                                  }
                                                                  name={key}
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    handleInputAmortissementsChange(
                                                                      rowData.index,
                                                                      e.target
                                                                        .name,
                                                                      e.target
                                                                        .value
                                                                    )
                                                                  }
                                                                />
                                                              ) : (
                                                                <span>
                                                                  {value}
                                                                </span>
                                                              )}
                                                            </td>
                                                          ) : (
                                                            <td
                                                              className="d-none"
                                                              key={key}
                                                            >
                                                              <input
                                                                type="hidden"
                                                                value={value}
                                                                readOnly
                                                              />
                                                            </td>
                                                          )
                                                        )}
                                                        <td
                                                          style={{
                                                            width: "1%",
                                                            textAlign: "center",
                                                          }}
                                                        >
                                                          <i
                                                            className="bx bx-trash"
                                                            style={{
                                                              fontSize: "20px",
                                                              paddingTop: "5px",
                                                              textAlign:
                                                                "center",
                                                              verticalAlign:
                                                                "middle",
                                                              cursor: "pointer",
                                                            }}
                                                            onClick={() =>
                                                              onDeleteFormAmortissements(
                                                                rowData.index
                                                              )
                                                            }
                                                          ></i>
                                                        </td>
                                                      </tr>
                                                    )
                                                  )}
                                                  <tr>
                                                    <td colSpan="9">
                                                      <button
                                                        type="button"
                                                        style={tableaustyles}
                                                        className="btn btn-info mt-3 mt-lg-0"
                                                        onClick={
                                                          onAddFormAmortissements
                                                        }
                                                      >
                                                        Ajouter
                                                      </button>
                                                    </td>
                                                  </tr>
                                                </tbody>
                                              </table>
                                            </div>
                                          </Col>
                                        </CardBody>
                                      </Collapse>
                                    </Card>
                                  </>
                                ) : null}
                              </Col>
                            </Col>
                            <Col sm="6">
                              {investData?.detail_investissement?.[
                                "Exploitation"
                              ] ? (
                                <Card
                                  className="shadow-sm border-0 overflow-hidden mb-4"
                                  style={{ borderRadius: "12px" }}
                                >
                                  {/* En‑tête cliquable */}
                                  <div
                                    className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                    style={{
                                      background: "#555B21",
                                      letterSpacing: "0.5px",
                                      cursor: "pointer",
                                      userSelect: "none",
                                    }}
                                    onClick={toggleExploitationAccordion}
                                  >
                                    <div className="d-flex align-items-center">
                                      <span style={{ fontSize: "0.82rem" }}>
                                        Exploitation
                                      </span>
                                    </div>
                                    {isExploitationAccordionOpen ? (
                                      <FiChevronUp size={16} />
                                    ) : (
                                      <FiChevronDown size={16} />
                                    )}
                                  </div>

                                  <Collapse
                                    isOpen={isExploitationAccordionOpen}
                                  >
                                    <CardBody className="p-0">
                                      {Object.entries(
                                        investData?.detail_investissement?.[
                                          "Exploitation"
                                        ] || {}
                                      ).map(([key, value], index) => (
                                        <React.Fragment key={index}>
                                          {key == "Exploitant" &&
                                          showField?.displayed_fields?.includes(
                                            "partenaire2_id"
                                          ) ? (
                                            <>
                                              <div
                                                className="field-item px-2 py-1"
                                                style={{
                                                  backgroundColor: "white",
                                                  transition: "all 0.15s ease",
                                                  borderLeft:
                                                    "3px solid transparent",
                                                  marginBottom: "1px",
                                                  position: "relative",
                                                }}
                                                onMouseEnter={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "#e3f2fd";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#007bff";
                                                }}
                                                onMouseLeave={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "white";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "transparent";
                                                }}
                                              >
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        {key}
                                                      </span>
                                                      <span className="ms-1 text-primary">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col xs={12} md={8}>
                                                    <Select
                                                      value={
                                                        selectedExploitant?.label ==
                                                        null
                                                          ? null
                                                          : selectedExploitant
                                                      }
                                                      onChange={
                                                        handleExploitantChange
                                                      }
                                                      options={renderExploitantOptions()}
                                                      isClearable
                                                      classNamePrefix="select2-selection"
                                                      styles={styles(false)}
                                                      menuPortalTarget={
                                                        document.body
                                                      }
                                                      placeholder="Sélectionner un Exploitant..."
                                                    />
                                                  </Col>
                                                </Row>
                                              </div>
                                            </>
                                          ) : key == "Section" &&
                                            showField?.displayed_fields?.includes(
                                              "section"
                                            ) ? (
                                            <>
                                              <div
                                                className="field-item px-2 py-1"
                                                style={{
                                                  backgroundColor: "white",
                                                  transition: "all 0.15s ease",
                                                  borderLeft:
                                                    "3px solid transparent",
                                                  marginBottom: "1px",
                                                  position: "relative",
                                                }}
                                                onMouseEnter={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "#e3f2fd";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#007bff";
                                                }}
                                                onMouseLeave={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "white";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "transparent";
                                                }}
                                              >
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        {key}
                                                      </span>
                                                      <span className="ms-1 text-primary">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col xs={12} md={8}>
                                                    <input
                                                      className="form-control form-control-sm shadow-sm border-0"
                                                      value={selectedSection}
                                                      required
                                                      onChange={
                                                        handleSectionChange
                                                      }
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        backgroundColor:
                                                          "#f8f9fa",
                                                        borderRadius: "6px",
                                                        padding:
                                                          "0.375rem 0.75rem",
                                                        height: "32px",
                                                      }}
                                                    />
                                                    <FiEdit3
                                                      size={12}
                                                      className="position-absolute text-muted"
                                                      style={{
                                                        right: "8px",
                                                        top: "50%",
                                                        transform:
                                                          "translateY(-50%)",
                                                        pointerEvents: "none",
                                                        opacity: 0.9,
                                                      }}
                                                    />
                                                  </Col>
                                                </Row>
                                              </div>
                                            </>
                                          ) : key == "N° cadastre" &&
                                            showField?.displayed_fields?.includes(
                                              "n_cadastre"
                                            ) ? (
                                            <>
                                              <div
                                                className="field-item px-2 py-1"
                                                style={{
                                                  backgroundColor: "white",
                                                  transition: "all 0.15s ease",
                                                  borderLeft:
                                                    "3px solid transparent",
                                                  marginBottom: "1px",
                                                  position: "relative",
                                                }}
                                                onMouseEnter={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "#e3f2fd";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#007bff";
                                                }}
                                                onMouseLeave={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "white";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "transparent";
                                                }}
                                              >
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        N° cadastre
                                                      </span>
                                                      <span className="ms-1 text-primary">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col xs={12} md={8}>
                                                    <input
                                                      className="form-control form-control-sm shadow-sm border-0"
                                                      value={selectedCadastre}
                                                      required
                                                      onChange={
                                                        handleCadastreChange
                                                      }
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        backgroundColor:
                                                          "#f8f9fa",
                                                        borderRadius: "6px",
                                                        padding:
                                                          "0.375rem 0.75rem",
                                                        height: "32px",
                                                      }}
                                                    />
                                                    <FiEdit3
                                                      size={12}
                                                      className="position-absolute text-muted"
                                                      style={{
                                                        right: "8px",
                                                        top: "50%",
                                                        transform:
                                                          "translateY(-50%)",
                                                        pointerEvents: "none",
                                                        opacity: 0.9,
                                                      }}
                                                    />
                                                  </Col>
                                                </Row>
                                              </div>
                                            </>
                                          ) : key == "Contenance" &&
                                            showField?.displayed_fields?.includes(
                                              "contenance"
                                            ) ? (
                                            <div
                                              className="field-item px-2 py-1"
                                              style={{
                                                backgroundColor: "white",
                                                transition: "all 0.15s ease",
                                                borderLeft:
                                                  "3px solid transparent",
                                                marginBottom: "1px",
                                                position: "relative",
                                              }}
                                              onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "#e3f2fd";
                                                e.currentTarget.style.borderLeftColor =
                                                  "#007bff";
                                              }}
                                              onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "white";
                                                e.currentTarget.style.borderLeftColor =
                                                  "transparent";
                                              }}
                                            >
                                              <Row className="align-items-center g-1">
                                                <Col xs={12} md={4}>
                                                  <div className="d-flex align-items-center small text-muted">
                                                    <span
                                                      className="fw-medium"
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        letterSpacing: "0.2px",
                                                      }}
                                                    >
                                                      Contenance
                                                    </span>
                                                    <span className="ms-1 text-primary">
                                                      :
                                                    </span>
                                                  </div>
                                                </Col>
                                                <Col xs={12} md={8}>
                                                  <input
                                                    className="form-control form-control-sm shadow-sm border-0"
                                                    value={selectedContenance}
                                                    required
                                                    onChange={
                                                      handleContenanceChange
                                                    }
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      backgroundColor:
                                                        "#f8f9fa",
                                                      borderRadius: "6px",
                                                      padding:
                                                        "0.375rem 0.75rem",
                                                      height: "32px",
                                                    }}
                                                  />
                                                  <FiEdit3
                                                    size={12}
                                                    className="position-absolute text-muted"
                                                    style={{
                                                      right: "8px",
                                                      top: "50%",
                                                      transform:
                                                        "translateY(-50%)",
                                                      pointerEvents: "none",
                                                      opacity: 0.9,
                                                    }}
                                                  />
                                                </Col>
                                              </Row>
                                            </div>
                                          ) : key == "Contenance 2" &&
                                            showField?.displayed_fields?.includes(
                                              "contenance"
                                            ) ? (
                                            <div
                                              className="field-item px-2 py-1"
                                              style={{
                                                backgroundColor: "white",
                                                transition: "all 0.15s ease",
                                                borderLeft:
                                                  "3px solid transparent",
                                                marginBottom: "1px",
                                                position: "relative",
                                              }}
                                              onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "#e3f2fd";
                                                e.currentTarget.style.borderLeftColor =
                                                  "#007bff";
                                              }}
                                              onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "white";
                                                e.currentTarget.style.borderLeftColor =
                                                  "transparent";
                                              }}
                                            >
                                              <Row className="align-items-center g-1">
                                                <Col xs={12} md={4}>
                                                  <div className="d-flex align-items-center small text-muted">
                                                    <span
                                                      className="fw-medium"
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        letterSpacing: "0.2px",
                                                      }}
                                                    >
                                                      Contenance 2
                                                    </span>
                                                    <span className="ms-1 text-primary">
                                                      :
                                                    </span>
                                                  </div>
                                                </Col>
                                                <Col xs={12} md={8}>
                                                  <input
                                                    className="form-control form-control-sm shadow-sm border-0"
                                                    value={selectedContenance2}
                                                    required
                                                    onChange={
                                                      handleContenance2Change
                                                    }
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      backgroundColor:
                                                        "#f8f9fa",
                                                      borderRadius: "6px",
                                                      padding:
                                                        "0.375rem 0.75rem",
                                                      height: "32px",
                                                    }}
                                                  />
                                                  <FiEdit3
                                                    size={12}
                                                    className="position-absolute text-muted"
                                                    style={{
                                                      right: "8px",
                                                      top: "50%",
                                                      transform:
                                                        "translateY(-50%)",
                                                      pointerEvents: "none",
                                                      opacity: 0.9,
                                                    }}
                                                  />
                                                </Col>
                                              </Row>
                                            </div>
                                          ) : key == "Nature" &&
                                            showField?.displayed_fields?.includes(
                                              "nature"
                                            ) ? (
                                            <div
                                              className="field-item px-2 py-1"
                                              style={{
                                                backgroundColor: "white",
                                                transition: "all 0.15s ease",
                                                borderLeft:
                                                  "3px solid transparent",
                                                marginBottom: "1px",
                                                position: "relative",
                                              }}
                                              onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "#e3f2fd";
                                                e.currentTarget.style.borderLeftColor =
                                                  "#007bff";
                                              }}
                                              onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "white";
                                                e.currentTarget.style.borderLeftColor =
                                                  "transparent";
                                              }}
                                            >
                                              <Row className="align-items-center g-1">
                                                <Col xs={12} md={4}>
                                                  <div className="d-flex align-items-center small text-muted">
                                                    <span
                                                      className="fw-medium"
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        letterSpacing: "0.2px",
                                                      }}
                                                    >
                                                      Nature
                                                    </span>
                                                    <span className="ms-1 text-primary">
                                                      :
                                                    </span>
                                                  </div>
                                                </Col>
                                                <Col xs={12} md={8}>
                                                  <input
                                                    className="form-control form-control-sm shadow-sm border-0"
                                                    value={selectedNature}
                                                    required
                                                    onChange={
                                                      handleNatureChange
                                                    }
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      backgroundColor:
                                                        "#f8f9fa",
                                                      borderRadius: "6px",
                                                      padding:
                                                        "0.375rem 0.75rem",
                                                      height: "32px",
                                                    }}
                                                  />
                                                  <FiEdit3
                                                    size={12}
                                                    className="position-absolute text-muted"
                                                    style={{
                                                      right: "8px",
                                                      top: "50%",
                                                      transform:
                                                        "translateY(-50%)",
                                                      pointerEvents: "none",
                                                      opacity: 0.9,
                                                    }}
                                                  />
                                                </Col>
                                              </Row>
                                            </div>
                                          ) : key == "Nature 2" &&
                                            showField?.displayed_fields?.includes(
                                              "nature"
                                            ) ? (
                                            <div
                                              className="field-item px-2 py-1"
                                              style={{
                                                backgroundColor: "white",
                                                transition: "all 0.15s ease",
                                                borderLeft:
                                                  "3px solid transparent",
                                                marginBottom: "1px",
                                                position: "relative",
                                              }}
                                              onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "#e3f2fd";
                                                e.currentTarget.style.borderLeftColor =
                                                  "#007bff";
                                              }}
                                              onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "white";
                                                e.currentTarget.style.borderLeftColor =
                                                  "transparent";
                                              }}
                                            >
                                              <Row className="align-items-center g-1">
                                                <Col xs={12} md={4}>
                                                  <div className="d-flex align-items-center small text-muted">
                                                    <span
                                                      className="fw-medium"
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        letterSpacing: "0.2px",
                                                      }}
                                                    >
                                                      Nature 2
                                                    </span>
                                                    <span className="ms-1 text-primary">
                                                      :
                                                    </span>
                                                  </div>
                                                </Col>
                                                <Col xs={12} md={8}>
                                                  <input
                                                    className="form-control form-control-sm shadow-sm border-0"
                                                    value={selectedNature2}
                                                    required
                                                    onChange={
                                                      handleNature2Change
                                                    }
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      backgroundColor:
                                                        "#f8f9fa",
                                                      borderRadius: "6px",
                                                      padding:
                                                        "0.375rem 0.75rem",
                                                      height: "32px",
                                                    }}
                                                  />
                                                  <FiEdit3
                                                    size={12}
                                                    className="position-absolute text-muted"
                                                    style={{
                                                      right: "8px",
                                                      top: "50%",
                                                      transform:
                                                        "translateY(-50%)",
                                                      pointerEvents: "none",
                                                      opacity: 0.9,
                                                    }}
                                                  />
                                                </Col>
                                              </Row>
                                            </div>
                                          ) : key == "Lieu-dit" &&
                                            showField?.displayed_fields?.includes(
                                              "lieudit"
                                            ) ? (
                                            <div
                                              className="field-item px-2 py-1"
                                              style={{
                                                backgroundColor: "white",
                                                transition: "all 0.15s ease",
                                                borderLeft:
                                                  "3px solid transparent",
                                                marginBottom: "1px",
                                                position: "relative",
                                              }}
                                              onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "#e3f2fd";
                                                e.currentTarget.style.borderLeftColor =
                                                  "#007bff";
                                              }}
                                              onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "white";
                                                e.currentTarget.style.borderLeftColor =
                                                  "transparent";
                                              }}
                                            >
                                              <Row className="align-items-center g-1">
                                                <Col xs={12} md={4}>
                                                  <div className="d-flex align-items-center small text-muted">
                                                    <span
                                                      className="fw-medium"
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        letterSpacing: "0.2px",
                                                      }}
                                                    >
                                                      Lieu-dit
                                                    </span>
                                                    <span className="ms-1 text-primary">
                                                      :
                                                    </span>
                                                  </div>
                                                </Col>
                                                <Col xs={12} md={8}>
                                                  <input
                                                    className="form-control form-control-sm shadow-sm border-0"
                                                    value={selectedLieuDit}
                                                    required
                                                    onChange={
                                                      handleLieuDitChange
                                                    }
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      backgroundColor:
                                                        "#f8f9fa",
                                                      borderRadius: "6px",
                                                      padding:
                                                        "0.375rem 0.75rem",
                                                      height: "32px",
                                                    }}
                                                  />
                                                  <FiEdit3
                                                    size={12}
                                                    className="position-absolute text-muted"
                                                    style={{
                                                      right: "8px",
                                                      top: "50%",
                                                      transform:
                                                        "translateY(-50%)",
                                                      pointerEvents: "none",
                                                      opacity: 0.9,
                                                    }}
                                                  />
                                                </Col>
                                              </Row>
                                            </div>
                                          ) : key == "Adresse" ? (
                                            <div
                                              className="field-item px-2 py-1"
                                              style={{
                                                backgroundColor: "white",
                                                transition: "all 0.15s ease",
                                                borderLeft:
                                                  "3px solid transparent",
                                                marginBottom: "1px",
                                                position: "relative",
                                              }}
                                              onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "#e3f2fd";
                                                e.currentTarget.style.borderLeftColor =
                                                  "#007bff";
                                              }}
                                              onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "white";
                                                e.currentTarget.style.borderLeftColor =
                                                  "transparent";
                                              }}
                                            >
                                              <Row className="align-items-center g-1">
                                                <Col xs={12} md={4}>
                                                  <div className="d-flex align-items-center small text-muted">
                                                    <span
                                                      className="fw-medium"
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        letterSpacing: "0.2px",
                                                      }}
                                                    >
                                                      Adresse
                                                    </span>
                                                    <span className="ms-1 text-primary">
                                                      :
                                                    </span>
                                                  </div>
                                                </Col>
                                                <Col xs={12} md={8}>
                                                  <input
                                                    className="form-control form-control-sm shadow-sm border-0"
                                                    value={selectedAdresse}
                                                    required
                                                    onChange={
                                                      handleAdresseChange
                                                    }
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      backgroundColor:
                                                        "#f8f9fa",
                                                      borderRadius: "6px",
                                                      padding:
                                                        "0.375rem 0.75rem",
                                                      height: "32px",
                                                    }}
                                                  />
                                                  <FiEdit3
                                                    size={12}
                                                    className="position-absolute text-muted"
                                                    style={{
                                                      right: "8px",
                                                      top: "50%",
                                                      transform:
                                                        "translateY(-50%)",
                                                      pointerEvents: "none",
                                                      opacity: 0.9,
                                                    }}
                                                  />
                                                </Col>
                                              </Row>
                                            </div>
                                          ) : key == "Code postal" &&
                                            showField?.displayed_fields?.includes(
                                              "code_postal"
                                            ) ? (
                                            <div
                                              className="field-item px-2 py-1"
                                              style={{
                                                backgroundColor: "white",
                                                transition: "all 0.15s ease",
                                                borderLeft:
                                                  "3px solid transparent",
                                                marginBottom: "1px",
                                                position: "relative",
                                              }}
                                              onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "#e3f2fd";
                                                e.currentTarget.style.borderLeftColor =
                                                  "#007bff";
                                              }}
                                              onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "white";
                                                e.currentTarget.style.borderLeftColor =
                                                  "transparent";
                                              }}
                                            >
                                              <Row className="align-items-center g-1">
                                                <Col xs={12} md={4}>
                                                  <div className="d-flex align-items-center small text-muted">
                                                    <span
                                                      className="fw-medium"
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        letterSpacing: "0.2px",
                                                      }}
                                                    >
                                                      Code postal
                                                    </span>
                                                    <span className="ms-1 text-primary">
                                                      :
                                                    </span>
                                                  </div>
                                                </Col>
                                                <Col xs={12} md={8}>
                                                  <input
                                                    className="form-control form-control-sm shadow-sm border-0"
                                                    value={selectedCodePostal}
                                                    required
                                                    onChange={
                                                      handleCodePostalChange
                                                    }
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      backgroundColor:
                                                        "#f8f9fa",
                                                      borderRadius: "6px",
                                                      padding:
                                                        "0.375rem 0.75rem",
                                                      height: "32px",
                                                    }}
                                                  />
                                                  <FiEdit3
                                                    size={12}
                                                    className="position-absolute text-muted"
                                                    style={{
                                                      right: "8px",
                                                      top: "50%",
                                                      transform:
                                                        "translateY(-50%)",
                                                      pointerEvents: "none",
                                                      opacity: 0.9,
                                                    }}
                                                  />
                                                </Col>
                                              </Row>
                                            </div>
                                          ) : key == "Commune" &&
                                            showField?.displayed_fields?.includes(
                                              "commune"
                                            ) ? (
                                            <div
                                              className="field-item px-2 py-1"
                                              style={{
                                                backgroundColor: "white",
                                                transition: "all 0.15s ease",
                                                borderLeft:
                                                  "3px solid transparent",
                                                marginBottom: "1px",
                                                position: "relative",
                                              }}
                                              onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "#e3f2fd";
                                                e.currentTarget.style.borderLeftColor =
                                                  "#007bff";
                                              }}
                                              onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "white";
                                                e.currentTarget.style.borderLeftColor =
                                                  "transparent";
                                              }}
                                            >
                                              <Row className="align-items-center g-1">
                                                <Col xs={12} md={4}>
                                                  <div className="d-flex align-items-center small text-muted">
                                                    <span
                                                      className="fw-medium"
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        letterSpacing: "0.2px",
                                                      }}
                                                    >
                                                      Commune
                                                    </span>
                                                    <span className="ms-1 text-primary">
                                                      :
                                                    </span>
                                                  </div>
                                                </Col>
                                                <Col xs={12} md={8}>
                                                  <input
                                                    className="form-control form-control-sm shadow-sm border-0"
                                                    value={selectedCommune}
                                                    required
                                                    onChange={
                                                      handleCommuneChange
                                                    }
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      backgroundColor:
                                                        "#f8f9fa",
                                                      borderRadius: "6px",
                                                      padding:
                                                        "0.375rem 0.75rem",
                                                      height: "32px",
                                                    }}
                                                  />
                                                  <FiEdit3
                                                    size={12}
                                                    className="position-absolute text-muted"
                                                    style={{
                                                      right: "8px",
                                                      top: "50%",
                                                      transform:
                                                        "translateY(-50%)",
                                                      pointerEvents: "none",
                                                      opacity: 0.9,
                                                    }}
                                                  />
                                                </Col>
                                              </Row>
                                            </div>
                                          ) : key == "Date PV livraison" &&
                                            showField?.displayed_fields?.includes(
                                              "date_pv_livraison"
                                            ) ? (
                                            <div
                                              className="field-item px-2 py-1"
                                              style={{
                                                backgroundColor: "white",
                                                transition: "all 0.15s ease",
                                                borderLeft:
                                                  "3px solid transparent",
                                                marginBottom: "1px",
                                                position: "relative",
                                              }}
                                              onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "#e3f2fd";
                                                e.currentTarget.style.borderLeftColor =
                                                  "#007bff";
                                              }}
                                              onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "white";
                                                e.currentTarget.style.borderLeftColor =
                                                  "transparent";
                                              }}
                                            >
                                              <Row className="align-items-center g-1">
                                                <Col xs={12} md={4}>
                                                  <div className="d-flex align-items-center small text-muted">
                                                    <span
                                                      className="fw-medium"
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        letterSpacing: "0.2px",
                                                      }}
                                                    >
                                                      {key}
                                                    </span>
                                                    <span className="ms-1 text-primary">
                                                      :
                                                    </span>
                                                  </div>
                                                </Col>
                                                <Col xs={12} md={8}>
                                                  <InputMask
                                                    mask="99/99/9999"
                                                    value={
                                                      selectedDateLivraison
                                                    }
                                                    className="form-control form-control-sm shadow-sm border-0 input-color"
                                                    onChange={(dateString) =>
                                                      setSelectedDateLivraison(
                                                        dateString.target.value
                                                      )
                                                    }
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      backgroundColor:
                                                        "#f8f9fa",
                                                      borderRadius: "6px",
                                                      padding:
                                                        "0.375rem 0.75rem",
                                                      height: "32px",
                                                    }}
                                                  />
                                                  <FiCalendar
                                                    size={12}
                                                    className="position-absolute text-muted"
                                                    style={{
                                                      right: "8px",
                                                      top: "50%",
                                                      transform:
                                                        "translateY(-50%)",
                                                      pointerEvents: "none",
                                                      opacity: 0.9,
                                                    }}
                                                  />
                                                </Col>
                                              </Row>
                                            </div>
                                          ) : key ==
                                              "Date obtention subvention" &&
                                            showField?.displayed_fields?.includes(
                                              "date_obtention_subvention"
                                            ) ? (
                                            <div
                                              className="field-item px-2 py-1"
                                              style={{
                                                backgroundColor: "white",
                                                transition: "all 0.15s ease",
                                                borderLeft:
                                                  "3px solid transparent",
                                                marginBottom: "1px",
                                                position: "relative",
                                              }}
                                              onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "#e3f2fd";
                                                e.currentTarget.style.borderLeftColor =
                                                  "#007bff";
                                              }}
                                              onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "white";
                                                e.currentTarget.style.borderLeftColor =
                                                  "transparent";
                                              }}
                                            >
                                              <Row className="align-items-center g-1">
                                                <Col xs={12} md={4}>
                                                  <div className="d-flex align-items-center small text-muted">
                                                    <span
                                                      className="fw-medium"
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        letterSpacing: "0.2px",
                                                      }}
                                                    >
                                                      {key}
                                                    </span>
                                                    <span className="ms-1 text-primary">
                                                      :
                                                    </span>
                                                  </div>
                                                </Col>
                                                <Col xs={12} md={8}>
                                                  <InputMask
                                                    mask="99/99/9999"
                                                    value={
                                                      selectedDateObtention
                                                    }
                                                    className="form-control form-control-sm shadow-sm border-0 input-color"
                                                    onChange={(dateString) =>
                                                      setSelectedDateObtention(
                                                        dateString.target.value
                                                      )
                                                    }
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      backgroundColor:
                                                        "#f8f9fa",
                                                      borderRadius: "6px",
                                                      padding:
                                                        "0.375rem 0.75rem",
                                                      height: "32px",
                                                    }}
                                                  />
                                                  <FiCalendar
                                                    size={12}
                                                    className="position-absolute text-muted"
                                                    style={{
                                                      right: "8px",
                                                      top: "50%",
                                                      transform:
                                                        "translateY(-50%)",
                                                      pointerEvents: "none",
                                                      opacity: 0.9,
                                                    }}
                                                  />
                                                </Col>
                                              </Row>
                                            </div>
                                          ) : key == "Montant (€)" ? (
                                            <div
                                              className="field-item px-2 py-1"
                                              style={{
                                                backgroundColor: "white",
                                                transition: "all 0.15s ease",
                                                borderLeft:
                                                  "3px solid transparent",
                                                marginBottom: "1px",
                                                position: "relative",
                                              }}
                                              onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "#e3f2fd";
                                                e.currentTarget.style.borderLeftColor =
                                                  "#007bff";
                                              }}
                                              onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "white";
                                                e.currentTarget.style.borderLeftColor =
                                                  "transparent";
                                              }}
                                            >
                                              <Row className="align-items-center g-1">
                                                <Col xs={12} md={4}>
                                                  <div className="d-flex align-items-center small text-muted">
                                                    <span
                                                      className="fw-medium"
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        letterSpacing: "0.2px",
                                                      }}
                                                    >
                                                      Montant (€)
                                                    </span>
                                                    <span className="ms-1 text-primary">
                                                      :
                                                    </span>
                                                  </div>
                                                </Col>
                                                <Col xs={12} md={8}>
                                                  <input
                                                    className="form-control form-control-sm shadow-sm border-0"
                                                    value={selectedMontant}
                                                    required
                                                    onChange={
                                                      handleMontantChange
                                                    }
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      backgroundColor:
                                                        "#f8f9fa",
                                                      borderRadius: "6px",
                                                      padding:
                                                        "0.375rem 0.75rem",
                                                      height: "32px",
                                                    }}
                                                  />
                                                  <FiEdit3
                                                    size={12}
                                                    className="position-absolute text-muted"
                                                    style={{
                                                      right: "8px",
                                                      top: "50%",
                                                      transform:
                                                        "translateY(-50%)",
                                                      pointerEvents: "none",
                                                      opacity: 0.9,
                                                    }}
                                                  />
                                                </Col>
                                              </Row>
                                            </div>
                                          ) : key == "Prix unitaire (€)" ? (
                                            <div
                                              className="field-item px-2 py-1"
                                              style={{
                                                backgroundColor: "white",
                                                transition: "all 0.15s ease",
                                                borderLeft:
                                                  "3px solid transparent",
                                                marginBottom: "1px",
                                                position: "relative",
                                              }}
                                              onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "#e3f2fd";
                                                e.currentTarget.style.borderLeftColor =
                                                  "#007bff";
                                              }}
                                              onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "white";
                                                e.currentTarget.style.borderLeftColor =
                                                  "transparent";
                                              }}
                                            >
                                              <Row className="align-items-center g-1">
                                                <Col xs={12} md={4}>
                                                  <div className="d-flex align-items-center small text-muted">
                                                    <span
                                                      className="fw-medium"
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        letterSpacing: "0.2px",
                                                      }}
                                                    >
                                                      Prix unitaire (€)
                                                    </span>
                                                    <span className="ms-1 text-primary">
                                                      :
                                                    </span>
                                                  </div>
                                                </Col>
                                                <Col xs={12} md={8}>
                                                  <input
                                                    className="form-control form-control-sm shadow-sm border-0"
                                                    value={selectedPrixUnitaire}
                                                    required
                                                    onChange={
                                                      handlePrixUnitaireChange
                                                    }
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      backgroundColor:
                                                        "#f8f9fa",
                                                      borderRadius: "6px",
                                                      padding:
                                                        "0.375rem 0.75rem",
                                                      height: "32px",
                                                    }}
                                                  />
                                                  <FiEdit3
                                                    size={12}
                                                    className="position-absolute text-muted"
                                                    style={{
                                                      right: "8px",
                                                      top: "50%",
                                                      transform:
                                                        "translateY(-50%)",
                                                      pointerEvents: "none",
                                                      opacity: 0.9,
                                                    }}
                                                  />
                                                </Col>
                                              </Row>
                                            </div>
                                          ) : key == "Montant 2 (€)" ? (
                                            <div
                                              className="field-item px-2 py-1"
                                              style={{
                                                backgroundColor: "white",
                                                transition: "all 0.15s ease",
                                                borderLeft:
                                                  "3px solid transparent",
                                                marginBottom: "1px",
                                                position: "relative",
                                              }}
                                              onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "#e3f2fd";
                                                e.currentTarget.style.borderLeftColor =
                                                  "#007bff";
                                              }}
                                              onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "white";
                                                e.currentTarget.style.borderLeftColor =
                                                  "transparent";
                                              }}
                                            >
                                              <Row className="align-items-center g-1">
                                                <Col xs={12} md={4}>
                                                  <div className="d-flex align-items-center small text-muted">
                                                    <span
                                                      className="fw-medium"
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        letterSpacing: "0.2px",
                                                      }}
                                                    >
                                                      Montant 2 (€)
                                                    </span>
                                                    <span className="ms-1 text-primary">
                                                      :
                                                    </span>
                                                  </div>
                                                </Col>
                                                <Col xs={12} md={8}>
                                                  <input
                                                    className="form-control form-control-sm shadow-sm border-0"
                                                    value={selectedMontant2}
                                                    required
                                                    onChange={
                                                      handleMontant2Change
                                                    }
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      backgroundColor:
                                                        "#f8f9fa",
                                                      borderRadius: "6px",
                                                      padding:
                                                        "0.375rem 0.75rem",
                                                      height: "32px",
                                                    }}
                                                  />
                                                  <FiEdit3
                                                    size={12}
                                                    className="position-absolute text-muted"
                                                    style={{
                                                      right: "8px",
                                                      top: "50%",
                                                      transform:
                                                        "translateY(-50%)",
                                                      pointerEvents: "none",
                                                      opacity: 0.9,
                                                    }}
                                                  />
                                                </Col>
                                              </Row>
                                            </div>
                                          ) : key == "Prix unitaire 2 (€)" ? (
                                            <div
                                              className="field-item px-2 py-1"
                                              style={{
                                                backgroundColor: "white",
                                                transition: "all 0.15s ease",
                                                borderLeft:
                                                  "3px solid transparent",
                                                marginBottom: "1px",
                                                position: "relative",
                                              }}
                                              onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "#e3f2fd";
                                                e.currentTarget.style.borderLeftColor =
                                                  "#007bff";
                                              }}
                                              onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "white";
                                                e.currentTarget.style.borderLeftColor =
                                                  "transparent";
                                              }}
                                            >
                                              <Row className="align-items-center g-1">
                                                <Col xs={12} md={4}>
                                                  <div className="d-flex align-items-center small text-muted">
                                                    <span
                                                      className="fw-medium"
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        letterSpacing: "0.2px",
                                                      }}
                                                    >
                                                      Prix unitaire 2 (€)
                                                    </span>
                                                    <span className="ms-1 text-primary">
                                                      :
                                                    </span>
                                                  </div>
                                                </Col>
                                                <Col xs={12} md={8}>
                                                  <input
                                                    className="form-control form-control-sm shadow-sm border-0"
                                                    value={
                                                      selectedPrixUnitaire2
                                                    }
                                                    required
                                                    onChange={
                                                      handlePrixUnitaire2Change
                                                    }
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      backgroundColor:
                                                        "#f8f9fa",
                                                      borderRadius: "6px",
                                                      padding:
                                                        "0.375rem 0.75rem",
                                                      height: "32px",
                                                    }}
                                                  />
                                                  <FiEdit3
                                                    size={12}
                                                    className="position-absolute text-muted"
                                                    style={{
                                                      right: "8px",
                                                      top: "50%",
                                                      transform:
                                                        "translateY(-50%)",
                                                      pointerEvents: "none",
                                                      opacity: 0.9,
                                                    }}
                                                  />
                                                </Col>
                                              </Row>
                                            </div>
                                          ) : key ==
                                              "% rétrocession exploitant" &&
                                            showField?.displayed_fields?.includes(
                                              "pourc_retrocession_exploitant"
                                            ) ? (
                                            <div
                                              className="field-item px-2 py-1"
                                              style={{
                                                backgroundColor: "white",
                                                transition: "all 0.15s ease",
                                                borderLeft:
                                                  "3px solid transparent",
                                                marginBottom: "1px",
                                                position: "relative",
                                              }}
                                              onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "#e3f2fd";
                                                e.currentTarget.style.borderLeftColor =
                                                  "#007bff";
                                              }}
                                              onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "white";
                                                e.currentTarget.style.borderLeftColor =
                                                  "transparent";
                                              }}
                                            >
                                              <Row className="align-items-center g-1">
                                                <Col xs={12} md={4}>
                                                  <div className="d-flex align-items-center small text-muted">
                                                    <span
                                                      className="fw-medium"
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        letterSpacing: "0.2px",
                                                      }}
                                                    >
                                                      % rétrocession exploitant
                                                    </span>
                                                    <span className="ms-1 text-primary">
                                                      :
                                                    </span>
                                                  </div>
                                                </Col>
                                                <Col xs={12} md={8}>
                                                  <input
                                                    className="form-control form-control-sm shadow-sm border-0"
                                                    value={
                                                      selectedPourcentageRetro
                                                    }
                                                    required
                                                    onChange={
                                                      handlePourcentageRetroChange
                                                    }
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      backgroundColor:
                                                        "#f8f9fa",
                                                      borderRadius: "6px",
                                                      padding:
                                                        "0.375rem 0.75rem",
                                                      height: "32px",
                                                    }}
                                                  />
                                                  <FiEdit3
                                                    size={12}
                                                    className="position-absolute text-muted"
                                                    style={{
                                                      right: "8px",
                                                      top: "50%",
                                                      transform:
                                                        "translateY(-50%)",
                                                      pointerEvents: "none",
                                                      opacity: 0.9,
                                                    }}
                                                  />
                                                </Col>
                                              </Row>
                                            </div>
                                          ) : key ==
                                            "Rétrocession exploitant (€)" ? (
                                            <div
                                              className="field-item px-2 py-1"
                                              style={{
                                                backgroundColor: "white",
                                                transition: "all 0.15s ease",
                                                borderLeft:
                                                  "3px solid transparent",
                                                marginBottom: "1px",
                                                position: "relative",
                                              }}
                                              onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "#e3f2fd";
                                                e.currentTarget.style.borderLeftColor =
                                                  "#007bff";
                                              }}
                                              onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "white";
                                                e.currentTarget.style.borderLeftColor =
                                                  "transparent";
                                              }}
                                            >
                                              <Row className="align-items-center g-1">
                                                <Col xs={12} md={4}>
                                                  <div className="d-flex align-items-center small text-muted">
                                                    <span
                                                      className="fw-medium"
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        letterSpacing: "0.2px",
                                                      }}
                                                    >
                                                      Rétrocession exploitant
                                                      (€)
                                                    </span>
                                                    <span className="ms-1 text-primary">
                                                      :
                                                    </span>
                                                  </div>
                                                </Col>
                                                <Col xs={12} md={8}>
                                                  <input
                                                    className="form-control form-control-sm shadow-sm border-0"
                                                    value={
                                                      selectedRetroExploitant
                                                    }
                                                    required
                                                    onChange={
                                                      handleRetroExploitantChange
                                                    }
                                                    disabled
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      backgroundColor:
                                                        "#f8f9fa",
                                                      borderRadius: "6px",
                                                      padding:
                                                        "0.375rem 0.75rem",
                                                      height: "32px",
                                                    }}
                                                  />
                                                </Col>
                                              </Row>
                                            </div>
                                          ) : key ==
                                              "Durée amortissement (mois)" &&
                                            showField?.displayed_fields?.includes(
                                              "duree_amortissement"
                                            ) ? (
                                            <div
                                              className="field-item px-2 py-1"
                                              style={{
                                                backgroundColor: "white",
                                                transition: "all 0.15s ease",
                                                borderLeft:
                                                  "3px solid transparent",
                                                marginBottom: "1px",
                                                position: "relative",
                                              }}
                                              onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "#e3f2fd";
                                                e.currentTarget.style.borderLeftColor =
                                                  "#007bff";
                                              }}
                                              onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "white";
                                                e.currentTarget.style.borderLeftColor =
                                                  "transparent";
                                              }}
                                            >
                                              <Row className="align-items-center g-1">
                                                <Col xs={12} md={4}>
                                                  <div className="d-flex align-items-center small text-muted">
                                                    <span
                                                      className="fw-medium"
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        letterSpacing: "0.2px",
                                                      }}
                                                    >
                                                      Durée amortissement (mois)
                                                    </span>
                                                    <span className="ms-1 text-primary">
                                                      :
                                                    </span>
                                                  </div>
                                                </Col>
                                                <Col xs={12} md={8}>
                                                  <input
                                                    className="form-control form-control-sm shadow-sm border-0"
                                                    value={
                                                      selectedDureeAmortissement
                                                    }
                                                    required
                                                    onChange={
                                                      handleDureeAmortissementChange
                                                    }
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      backgroundColor:
                                                        "#f8f9fa",
                                                      borderRadius: "6px",
                                                      padding:
                                                        "0.375rem 0.75rem",
                                                      height: "32px",
                                                    }}
                                                  />
                                                  <FiEdit3
                                                    size={12}
                                                    className="position-absolute text-muted"
                                                    style={{
                                                      right: "8px",
                                                      top: "50%",
                                                      transform:
                                                        "translateY(-50%)",
                                                      pointerEvents: "none",
                                                      opacity: 0.9,
                                                    }}
                                                  />
                                                </Col>
                                              </Row>
                                            </div>
                                          ) : key == "Agrément" &&
                                            showField?.displayed_fields?.includes(
                                              "agrement"
                                            ) ? (
                                            <div
                                              className="field-item px-2 py-1"
                                              style={{
                                                backgroundColor: "white",
                                                transition: "all 0.15s ease",
                                                borderLeft:
                                                  "3px solid transparent",
                                                marginBottom: "1px",
                                                position: "relative",
                                              }}
                                              onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "#e3f2fd";
                                                e.currentTarget.style.borderLeftColor =
                                                  "#007bff";
                                              }}
                                              onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "white";
                                                e.currentTarget.style.borderLeftColor =
                                                  "transparent";
                                              }}
                                            >
                                              <Row className="align-items-center g-1">
                                                <Col xs={12} md={4}>
                                                  <div className="d-flex align-items-center small text-muted">
                                                    <span
                                                      className="fw-medium"
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        letterSpacing: "0.2px",
                                                      }}
                                                    >
                                                      Agrément
                                                    </span>
                                                    <span className="ms-1 text-primary">
                                                      :
                                                    </span>
                                                  </div>
                                                </Col>
                                                <Col xs={12} md={8}>
                                                  <input
                                                    className="form-control form-control-sm shadow-sm border-0"
                                                    value={selectedAgrement}
                                                    required
                                                    onChange={
                                                      handleAgrementChange
                                                    }
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      backgroundColor:
                                                        "#f8f9fa",
                                                      borderRadius: "6px",
                                                      padding:
                                                        "0.375rem 0.75rem",
                                                      height: "32px",
                                                    }}
                                                  />
                                                  <FiEdit3
                                                    size={12}
                                                    className="position-absolute text-muted"
                                                    style={{
                                                      right: "8px",
                                                      top: "50%",
                                                      transform:
                                                        "translateY(-50%)",
                                                      pointerEvents: "none",
                                                      opacity: 0.9,
                                                    }}
                                                  />
                                                </Col>
                                              </Row>
                                            </div>
                                          ) : null}
                                        </React.Fragment>
                                      ))}
                                    </CardBody>
                                  </Collapse>
                                </Card>
                              ) : null}

                              {sections.map((section, sectionIndex) => (
                                <>
                                  {investData?.detail_investissement?.[
                                    section.key
                                  ] ? (
                                    <Card
                                      className="shadow-sm border-0 overflow-hidden mb-4"
                                      style={{ borderRadius: "12px" }}
                                    >
                                      {/* En‑tête cliquable */}
                                      <div
                                        className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                        style={{
                                          background: "#555B21",
                                          letterSpacing: "0.5px",
                                          cursor: "pointer",
                                          userSelect: "none",
                                        }}
                                        onClick={() =>
                                          toggleSectionAccordion(section.key)
                                        }
                                      >
                                        <div className="d-flex align-items-center">
                                          <span style={{ fontSize: "0.82rem" }}>
                                            {section.title}
                                          </span>
                                        </div>
                                        {openSections[section.key] ? (
                                          <FiChevronUp size={16} />
                                        ) : (
                                          <FiChevronDown size={16} />
                                        )}
                                      </div>

                                      <Collapse
                                        isOpen={!openSections[section.key]}
                                      >
                                        <CardBody className="p-0">
                                          {Object.entries(
                                            investData?.detail_investissement?.[
                                              section.key
                                            ] || {}
                                          ).map(([key, value], index) => (
                                            <React.Fragment key={index}>
                                              {key == "Contenance" &&
                                              showField?.displayed_fields?.includes(
                                                "contenance"
                                              ) ? (
                                                <div
                                                  className="field-item px-2 py-1"
                                                  style={{
                                                    backgroundColor: "white",
                                                    transition:
                                                      "all 0.15s ease",
                                                    borderLeft:
                                                      "3px solid transparent",
                                                    marginBottom: "1px",
                                                    position: "relative",
                                                  }}
                                                  onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#e3f2fd";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#007bff";
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "transparent";
                                                  }}
                                                >
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          Contenance
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <input
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        value={
                                                          selectedContenance
                                                        }
                                                        required
                                                        onChange={
                                                          handleContenanceChange
                                                        }
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 0.75rem",
                                                          height: "32px",
                                                        }}
                                                      />
                                                      <FiEdit3
                                                        size={12}
                                                        className="position-absolute text-muted"
                                                        style={{
                                                          right: "8px",
                                                          top: "50%",
                                                          transform:
                                                            "translateY(-50%)",
                                                          pointerEvents: "none",
                                                          opacity: 0.9,
                                                        }}
                                                      />
                                                    </Col>
                                                  </Row>
                                                </div>
                                              ) : key == "Contenance 2" &&
                                                showField?.displayed_fields?.includes(
                                                  "contenance"
                                                ) ? (
                                                <div
                                                  className="field-item px-2 py-1"
                                                  style={{
                                                    backgroundColor: "white",
                                                    transition:
                                                      "all 0.15s ease",
                                                    borderLeft:
                                                      "3px solid transparent",
                                                    marginBottom: "1px",
                                                    position: "relative",
                                                  }}
                                                  onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#e3f2fd";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#007bff";
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "transparent";
                                                  }}
                                                >
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          Contenance 2
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <input
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        value={
                                                          selectedContenance2
                                                        }
                                                        required
                                                        onChange={
                                                          handleContenance2Change
                                                        }
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 0.75rem",
                                                          height: "32px",
                                                        }}
                                                      />
                                                      <FiEdit3
                                                        size={12}
                                                        className="position-absolute text-muted"
                                                        style={{
                                                          right: "8px",
                                                          top: "50%",
                                                          transform:
                                                            "translateY(-50%)",
                                                          pointerEvents: "none",
                                                          opacity: 0.9,
                                                        }}
                                                      />
                                                    </Col>
                                                  </Row>
                                                </div>
                                              ) : key == "Nature" &&
                                                showField?.displayed_fields?.includes(
                                                  "nature"
                                                ) ? (
                                                <div
                                                  className="field-item px-2 py-1"
                                                  style={{
                                                    backgroundColor: "white",
                                                    transition:
                                                      "all 0.15s ease",
                                                    borderLeft:
                                                      "3px solid transparent",
                                                    marginBottom: "1px",
                                                    position: "relative",
                                                  }}
                                                  onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#e3f2fd";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#007bff";
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "transparent";
                                                  }}
                                                >
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          Nature
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <input
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        value={selectedNature}
                                                        required
                                                        onChange={
                                                          handleNatureChange
                                                        }
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 0.75rem",
                                                          height: "32px",
                                                        }}
                                                      />
                                                      <FiEdit3
                                                        size={12}
                                                        className="position-absolute text-muted"
                                                        style={{
                                                          right: "8px",
                                                          top: "50%",
                                                          transform:
                                                            "translateY(-50%)",
                                                          pointerEvents: "none",
                                                          opacity: 0.9,
                                                        }}
                                                      />
                                                    </Col>
                                                  </Row>
                                                </div>
                                              ) : key == "Nature 2" &&
                                                showField?.displayed_fields?.includes(
                                                  "nature"
                                                ) ? (
                                                <div
                                                  className="field-item px-2 py-1"
                                                  style={{
                                                    backgroundColor: "white",
                                                    transition:
                                                      "all 0.15s ease",
                                                    borderLeft:
                                                      "3px solid transparent",
                                                    marginBottom: "1px",
                                                    position: "relative",
                                                  }}
                                                  onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#e3f2fd";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#007bff";
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "transparent";
                                                  }}
                                                >
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          Nature 2
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <input
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        value={selectedNature2}
                                                        required
                                                        onChange={
                                                          handleNature2Change
                                                        }
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 0.75rem",
                                                          height: "32px",
                                                        }}
                                                      />
                                                      <FiEdit3
                                                        size={12}
                                                        className="position-absolute text-muted"
                                                        style={{
                                                          right: "8px",
                                                          top: "50%",
                                                          transform:
                                                            "translateY(-50%)",
                                                          pointerEvents: "none",
                                                          opacity: 0.9,
                                                        }}
                                                      />
                                                    </Col>
                                                  </Row>
                                                </div>
                                              ) : key ==
                                                  "Date obtention subvention" &&
                                                showField?.displayed_fields?.includes(
                                                  "date_obtention_subvention"
                                                ) ? (
                                                <>
                                                  <Col
                                                    xs={12}
                                                    md={12}
                                                    lg={4}
                                                    style={colStyle}
                                                  >
                                                    <i
                                                      style={{
                                                        color: "#9d9c9c",
                                                      }}
                                                    >
                                                      <span
                                                        style={{
                                                          display:
                                                            "inline-block",
                                                          width: "8em",
                                                          whiteSpace: "wrap",
                                                        }}
                                                      >
                                                        {key}:
                                                      </span>
                                                    </i>
                                                  </Col>
                                                  <Col className="col-md-6">
                                                    <InputMask
                                                      mask="99/99/9999"
                                                      value={
                                                        selectedDateObtention
                                                      }
                                                      className="form-control form-control-sm input-color"
                                                      onChange={(
                                                        dateString
                                                      ) => {
                                                        setSelectedDateObtention(
                                                          dateString.target
                                                            .value
                                                        );
                                                      }}
                                                    />
                                                  </Col>
                                                </>
                                              ) : key == "Montant (€)" ? (
                                                <div
                                                  className="field-item px-2 py-1"
                                                  style={{
                                                    backgroundColor: "white",
                                                    transition:
                                                      "all 0.15s ease",
                                                    borderLeft:
                                                      "3px solid transparent",
                                                    marginBottom: "1px",
                                                    position: "relative",
                                                  }}
                                                  onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#e3f2fd";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#007bff";
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "transparent";
                                                  }}
                                                >
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          Montant (€)
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <input
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        value={selectedMontant}
                                                        required
                                                        onChange={
                                                          handleMontantChange
                                                        }
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 0.75rem",
                                                          height: "32px",
                                                        }}
                                                      />
                                                      <FiEdit3
                                                        size={12}
                                                        className="position-absolute text-muted"
                                                        style={{
                                                          right: "8px",
                                                          top: "50%",
                                                          transform:
                                                            "translateY(-50%)",
                                                          pointerEvents: "none",
                                                          opacity: 0.9,
                                                        }}
                                                      />
                                                    </Col>
                                                  </Row>
                                                </div>
                                              ) : key == "Prix unitaire (€)" ? (
                                                <div
                                                  className="field-item px-2 py-1"
                                                  style={{
                                                    backgroundColor: "white",
                                                    transition:
                                                      "all 0.15s ease",
                                                    borderLeft:
                                                      "3px solid transparent",
                                                    marginBottom: "1px",
                                                    position: "relative",
                                                  }}
                                                  onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#e3f2fd";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#007bff";
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "transparent";
                                                  }}
                                                >
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          Prix unitaire (€)
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <input
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        value={
                                                          selectedPrixUnitaire
                                                        }
                                                        required
                                                        onChange={
                                                          handlePrixUnitaireChange
                                                        }
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 0.75rem",
                                                          height: "32px",
                                                        }}
                                                      />
                                                      <FiEdit3
                                                        size={12}
                                                        className="position-absolute text-muted"
                                                        style={{
                                                          right: "8px",
                                                          top: "50%",
                                                          transform:
                                                            "translateY(-50%)",
                                                          pointerEvents: "none",
                                                          opacity: 0.9,
                                                        }}
                                                      />
                                                    </Col>
                                                  </Row>
                                                </div>
                                              ) : key == "Montant 2 (€)" ? (
                                                <div
                                                  className="field-item px-2 py-1"
                                                  style={{
                                                    backgroundColor: "white",
                                                    transition:
                                                      "all 0.15s ease",
                                                    borderLeft:
                                                      "3px solid transparent",
                                                    marginBottom: "1px",
                                                    position: "relative",
                                                  }}
                                                  onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#e3f2fd";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#007bff";
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "transparent";
                                                  }}
                                                >
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          Montant 2 (€)
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <input
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        value={selectedMontant2}
                                                        required
                                                        onChange={
                                                          handleMontant2Change
                                                        }
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 0.75rem",
                                                          height: "32px",
                                                        }}
                                                      />
                                                      <FiEdit3
                                                        size={12}
                                                        className="position-absolute text-muted"
                                                        style={{
                                                          right: "8px",
                                                          top: "50%",
                                                          transform:
                                                            "translateY(-50%)",
                                                          pointerEvents: "none",
                                                          opacity: 0.9,
                                                        }}
                                                      />
                                                    </Col>
                                                  </Row>
                                                </div>
                                              ) : key ==
                                                "Prix unitaire 2 (€)" ? (
                                                <div
                                                  className="field-item px-2 py-1"
                                                  style={{
                                                    backgroundColor: "white",
                                                    transition:
                                                      "all 0.15s ease",
                                                    borderLeft:
                                                      "3px solid transparent",
                                                    marginBottom: "1px",
                                                    position: "relative",
                                                  }}
                                                  onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#e3f2fd";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#007bff";
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "transparent";
                                                  }}
                                                >
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          Prix unitaire 2 (€)
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <input
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        value={
                                                          selectedPrixUnitaire2
                                                        }
                                                        required
                                                        onChange={
                                                          handlePrixUnitaire2Change
                                                        }
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 0.75rem",
                                                          height: "32px",
                                                        }}
                                                      />
                                                      <FiEdit3
                                                        size={12}
                                                        className="position-absolute text-muted"
                                                        style={{
                                                          right: "8px",
                                                          top: "50%",
                                                          transform:
                                                            "translateY(-50%)",
                                                          pointerEvents: "none",
                                                          opacity: 0.9,
                                                        }}
                                                      />
                                                    </Col>
                                                  </Row>
                                                </div>
                                              ) : key ==
                                                  "% rétrocession exploitant" &&
                                                showField?.displayed_fields?.includes(
                                                  "pourc_retrocession_exploitant"
                                                ) ? (
                                                <div
                                                  className="field-item px-2 py-1"
                                                  style={{
                                                    backgroundColor: "white",
                                                    transition:
                                                      "all 0.15s ease",
                                                    borderLeft:
                                                      "3px solid transparent",
                                                    marginBottom: "1px",
                                                    position: "relative",
                                                  }}
                                                  onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#e3f2fd";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#007bff";
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "transparent";
                                                  }}
                                                >
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          % rétrocession
                                                          exploitant
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <input
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        value={
                                                          selectedPourcentageRetro
                                                        }
                                                        required
                                                        onChange={
                                                          handlePourcentageRetroChange
                                                        }
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 0.75rem",
                                                          height: "32px",
                                                        }}
                                                      />
                                                      <FiEdit3
                                                        size={12}
                                                        className="position-absolute text-muted"
                                                        style={{
                                                          right: "8px",
                                                          top: "50%",
                                                          transform:
                                                            "translateY(-50%)",
                                                          pointerEvents: "none",
                                                          opacity: 0.9,
                                                        }}
                                                      />
                                                    </Col>
                                                  </Row>
                                                </div>
                                              ) : key ==
                                                "Rétrocession exploitant (€)" ? (
                                                <div
                                                  className="field-item px-2 py-1"
                                                  style={{
                                                    backgroundColor: "white",
                                                    transition:
                                                      "all 0.15s ease",
                                                    borderLeft:
                                                      "3px solid transparent",
                                                    marginBottom: "1px",
                                                    position: "relative",
                                                  }}
                                                  onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#e3f2fd";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#007bff";
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "transparent";
                                                  }}
                                                >
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          Rétrocession
                                                          exploitant (€)
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <input
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        value={
                                                          selectedRetroExploitant
                                                        }
                                                        required
                                                        onChange={
                                                          handleRetroExploitantChange
                                                        }
                                                        disabled
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 0.75rem",
                                                          height: "32px",
                                                        }}
                                                      />
                                                    </Col>
                                                  </Row>
                                                </div>
                                              ) : key ==
                                                  "Durée amortissement (mois)" &&
                                                showField?.displayed_fields?.includes(
                                                  "duree_amortissement"
                                                ) ? (
                                                <div
                                                  className="field-item px-2 py-1"
                                                  style={{
                                                    backgroundColor: "white",
                                                    transition:
                                                      "all 0.15s ease",
                                                    borderLeft:
                                                      "3px solid transparent",
                                                    marginBottom: "1px",
                                                    position: "relative",
                                                  }}
                                                  onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#e3f2fd";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#007bff";
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "transparent";
                                                  }}
                                                >
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          Durée amortissement
                                                          (mois)
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <input
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        value={
                                                          selectedDureeAmortissement
                                                        }
                                                        required
                                                        onChange={
                                                          handleDureeAmortissementChange
                                                        }
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 0.75rem",
                                                          height: "32px",
                                                        }}
                                                      />
                                                      <FiEdit3
                                                        size={12}
                                                        className="position-absolute text-muted"
                                                        style={{
                                                          right: "8px",
                                                          top: "50%",
                                                          transform:
                                                            "translateY(-50%)",
                                                          pointerEvents: "none",
                                                          opacity: 0.9,
                                                        }}
                                                      />
                                                    </Col>
                                                  </Row>
                                                </div>
                                              ) : key == "Base éligible (€)" &&
                                                showField?.displayed_fields?.includes(
                                                  "base_eligible_investissement"
                                                ) ? (
                                                <div
                                                  className="field-item px-2 py-1"
                                                  style={{
                                                    backgroundColor: "white",
                                                    transition:
                                                      "all 0.15s ease",
                                                    borderLeft:
                                                      "3px solid transparent",
                                                    marginBottom: "1px",
                                                    position: "relative",
                                                  }}
                                                  onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#e3f2fd";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#007bff";
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "transparent";
                                                  }}
                                                >
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          Base éligible (€)
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <input
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        value={
                                                          selectedBaseEligible
                                                        }
                                                        required
                                                        onChange={
                                                          handleBaseEligibleChange
                                                        }
                                                        disabled
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 0.75rem",
                                                          height: "32px",
                                                        }}
                                                      />
                                                    </Col>
                                                  </Row>
                                                </div>
                                              ) : key ==
                                                  "Réduction impôt (€)" &&
                                                showField?.displayed_fields?.includes(
                                                  "reduction_impot"
                                                ) ? (
                                                <div
                                                  className="field-item px-2 py-1"
                                                  style={{
                                                    backgroundColor: "white",
                                                    transition:
                                                      "all 0.15s ease",
                                                    borderLeft:
                                                      "3px solid transparent",
                                                    marginBottom: "1px",
                                                    position: "relative",
                                                  }}
                                                  onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#e3f2fd";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#007bff";
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "transparent";
                                                  }}
                                                >
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          Réduction impôt (€)
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <input
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        value={
                                                          selectedReductionImpot
                                                        }
                                                        required
                                                        onChange={
                                                          handleReductionImpotChange
                                                        }
                                                        disabled
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 0.75rem",
                                                          height: "32px",
                                                        }}
                                                      />
                                                    </Col>
                                                  </Row>
                                                </div>
                                              ) : key == "% réduction impôt" &&
                                                showField?.displayed_fields?.includes(
                                                  "taux_reduction_impot"
                                                ) ? (
                                                <div
                                                  className="field-item px-2 py-1"
                                                  style={{
                                                    backgroundColor: "white",
                                                    transition:
                                                      "all 0.15s ease",
                                                    borderLeft:
                                                      "3px solid transparent",
                                                    marginBottom: "1px",
                                                    position: "relative",
                                                  }}
                                                  onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#e3f2fd";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#007bff";
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "transparent";
                                                  }}
                                                >
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          % réduction impôt
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <input
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        value={
                                                          selectedPourcentageReductionImpot
                                                        }
                                                        required
                                                        onChange={
                                                          handlePourcentageReductionImpotChange
                                                        }
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 0.75rem",
                                                          height: "32px",
                                                        }}
                                                      />
                                                      <FiEdit3
                                                        size={12}
                                                        className="position-absolute text-muted"
                                                        style={{
                                                          right: "8px",
                                                          top: "50%",
                                                          transform:
                                                            "translateY(-50%)",
                                                          pointerEvents: "none",
                                                          opacity: 0.9,
                                                        }}
                                                      />
                                                    </Col>
                                                  </Row>
                                                </div>
                                              ) : key == "Subvention" ? (
                                                <>
                                                  <Col
                                                    xs={12}
                                                    md={12}
                                                    lg={4}
                                                    style={colStyle}
                                                  >
                                                    <i
                                                      style={{
                                                        color: "#9d9c9c",
                                                      }}
                                                    >
                                                      <span
                                                        style={{
                                                          display:
                                                            "inline-block",
                                                          width: "8em",
                                                          whiteSpace: "nowrap",
                                                          paddingTop: 10,
                                                        }}
                                                      >
                                                        {key}*:
                                                      </span>
                                                    </i>
                                                  </Col>
                                                  <Col className="col-md-6">
                                                    <Select
                                                      defaultValue={
                                                        selectedSubvention?.label ==
                                                        null
                                                          ? null
                                                          : selectedSubvention
                                                      }
                                                      onChange={
                                                        handleSubventionChange
                                                      }
                                                      options={renderOuiNonOptions()}
                                                      isClearable={true}
                                                      className="select2"
                                                      styles={styles(
                                                        selectedSubvention ==
                                                          null
                                                      )}
                                                    />
                                                    {selectedSubvention ===
                                                    null ? (
                                                      <div
                                                        style={{
                                                          color: "red",
                                                          whiteSpace: "nowrap",
                                                        }}
                                                      >
                                                        Statut ne peut pas être
                                                        vide
                                                      </div>
                                                    ) : (
                                                      ""
                                                    )}
                                                  </Col>
                                                </>
                                              ) : key == "Partie versante" ? (
                                                <>
                                                  <Col
                                                    xs={12}
                                                    md={12}
                                                    lg={4}
                                                    style={colStyle}
                                                  >
                                                    <i
                                                      style={{
                                                        color: "#9d9c9c",
                                                      }}
                                                    >
                                                      <span
                                                        style={{
                                                          display:
                                                            "inline-block",
                                                          width: "8em",
                                                          whiteSpace: "nowrap",
                                                          paddingTop: 10,
                                                        }}
                                                      >
                                                        {key}:
                                                      </span>
                                                    </i>
                                                  </Col>
                                                  <Col className="col-md-6">
                                                    <Select
                                                      defaultValue={
                                                        selectedPartieVersante?.label ==
                                                        null
                                                          ? null
                                                          : selectedPartieVersante
                                                      }
                                                      onChange={
                                                        handlePartieVersanteChange
                                                      }
                                                      options={renderPartieOptions()}
                                                      isClearable={true}
                                                      className="select2"
                                                      styles={styles(
                                                        selectedPartieVersante ==
                                                          null
                                                      )}
                                                    />
                                                  </Col>
                                                </>
                                              ) : key == "Subventions (€)" &&
                                                showField?.displayed_fields?.includes(
                                                  "subvention"
                                                ) ? (
                                                <>
                                                  <Col
                                                    xs={12}
                                                    md={12}
                                                    lg={4}
                                                    style={colStyle}
                                                  >
                                                    <i
                                                      style={{
                                                        color: "#9d9c9c",
                                                      }}
                                                    >
                                                      <span
                                                        style={{
                                                          display:
                                                            "inline-block",
                                                          width: "8em",
                                                          whiteSpace: "nowrap",
                                                          paddingTop: 10,
                                                        }}
                                                      >
                                                        {key}:
                                                      </span>
                                                    </i>
                                                  </Col>
                                                  <Col className="col-md-6">
                                                    <input
                                                      className="form-control form-control-sm"
                                                      defaultValue={
                                                        selectedSubvention2
                                                      }
                                                      required
                                                      onChange={
                                                        handleSubvention2Change
                                                      }
                                                    />
                                                  </Col>
                                                </>
                                              ) : key == "Base éligible (€)" &&
                                                showField?.displayed_fields?.includes(
                                                  "base_eligible_investissement"
                                                ) ? (
                                                <>
                                                  <Col
                                                    xs={12}
                                                    md={12}
                                                    lg={4}
                                                    style={colStyle}
                                                  >
                                                    <i
                                                      style={{
                                                        color: "#9d9c9c",
                                                      }}
                                                    >
                                                      <span
                                                        style={{
                                                          display:
                                                            "inline-block",
                                                          width: "8em",
                                                          whiteSpace: "nowrap",
                                                          paddingTop: "10px",
                                                        }}
                                                      >
                                                        {key}:
                                                      </span>
                                                    </i>
                                                  </Col>
                                                  <Col className="col-md-6">
                                                    <input
                                                      className="form-control form-control-sm"
                                                      value={
                                                        selectedBaseEligible
                                                      }
                                                      required
                                                      onChange={
                                                        handleBaseEligibleChange
                                                      }
                                                      disabled
                                                    />
                                                  </Col>
                                                </>
                                              ) : key ==
                                                  "Réduction impôt (€)" &&
                                                showField?.displayed_fields?.includes(
                                                  "reduction_impot"
                                                ) ? (
                                                <>
                                                  <Col
                                                    xs={12}
                                                    md={12}
                                                    lg={4}
                                                    style={colStyle}
                                                  >
                                                    <i
                                                      style={{
                                                        color: "#9d9c9c",
                                                      }}
                                                    >
                                                      <span
                                                        style={{
                                                          display:
                                                            "inline-block",
                                                          width: "8em",
                                                          whiteSpace: "nowrap",
                                                          paddingTop: "10px",
                                                        }}
                                                      >
                                                        {key}:
                                                      </span>
                                                    </i>
                                                  </Col>
                                                  <Col className="col-md-6">
                                                    <input
                                                      className="form-control form-control-sm"
                                                      value={
                                                        selectedReductionImpot
                                                      }
                                                      required
                                                      onChange={
                                                        handleReductionImpotChange
                                                      }
                                                      disabled
                                                    />
                                                  </Col>
                                                </>
                                              ) : key == "% réduction impôt" &&
                                                showField?.displayed_fields?.includes(
                                                  "taux_reduction_impot"
                                                ) ? (
                                                <>
                                                  <Col
                                                    xs={12}
                                                    md={12}
                                                    lg={4}
                                                    style={colStyle}
                                                  >
                                                    <i
                                                      style={{
                                                        color: "#9d9c9c",
                                                      }}
                                                    >
                                                      <span
                                                        style={{
                                                          display:
                                                            "inline-block",
                                                          width: "8em",
                                                          whiteSpace: "nowrap",
                                                          paddingTop: "10px",
                                                        }}
                                                      >
                                                        {key}:
                                                      </span>
                                                    </i>
                                                  </Col>
                                                  <Col className="col-md-6">
                                                    <input
                                                      className="form-control form-control-sm"
                                                      value={
                                                        selectedPourcentageReductionImpot
                                                      }
                                                      required
                                                      onChange={
                                                        handlePourcentageReductionImpotChange
                                                      }
                                                    />
                                                  </Col>
                                                </>
                                              ) : null}
                                            </React.Fragment>
                                          ))}
                                        </CardBody>
                                      </Collapse>
                                    </Card>
                                  ) : null}
                                </>
                              ))}
                            </Col>{" "}
                            <Col sm="12">{/*  */}</Col>
                          </Row>
                        </>
                      ) : (
                        <Spinners setLoading={setLoading} setWait={wait} />
                      )}
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      <ToastContainer />
    </React.Fragment>
  );
};

export default investissEdit;
